import '../../app-configuration/app-configuration.js';
/* Polymer */
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';
import { dom } from '@polymer/polymer/lib/legacy/polymer.dom.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
import { KatapultGeometry } from 'katapult-toolbox';

/* Elements */
import '@polymer/paper-input/paper-textarea.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/maps-icons.js';
import '@polymer/iron-icons/image-icons.js';
import '@polymer/iron-icons/av-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-collapse/iron-collapse.js';
import 'iron-a11y-keys/iron-a11y-keys.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/paper-tabs/paper-tabs.js';
import '@polymer/paper-tabs/paper-tab.js';
import '@polymer/iron-pages/iron-pages.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/neon-animation/neon-animation-runner-behavior.js';
import '@polymer/neon-animation/animations/fade-in-animation.js';
import '@polymer/neon-animation/animations/fade-out-animation.js';
import '@polymer/paper-dialog/paper-dialog.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-material/paper-material.js';
import '@polymer/paper-toggle-button/paper-toggle-button.js';
import '@polymer/paper-checkbox/paper-checkbox.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/iron-localstorage/iron-localstorage.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/editor-icons.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/neon-animation/neon-animations.js';
import '@polymer/paper-styles/shadow.js';
import '@polymer/paper-styles/typography.js';
import '@polymer/paper-slider/paper-slider.js';

/* Katapult Elements */
import '../katapult-toolbar/katapult-toolbar.js';
import '../katapult-photo-label/katapult-photo-label.js';
import '../katapult-drop-down/katapult-drop-down.js';
import '../model-loader/model-loader.js';
import '../katapult-photo/katapult-photo-viewer.js';
import '../katapult-photo/katapult-photo-annotation.js';
import '../katapult-photo/katapult-photo-chooser.js';
import '../replace-action-dialog/replace-action-dialog.js';
import '../avatar-icon/avatar-icon.js';
import '../katapult-auth/katapult-auth.js';
import '../job-chooser/job-chooser.js';
import '../photo-first/hardware-details.js';
import '../photo-first/photo-controls.js';
import '../photo-first/upshot-measurement.js';
import '../job-chooser/project-folder-chooser.js';
import '../user-chip/user-chip.js';
import calibratePhoto from '../calibrate-photo/calibrate-photo.js';
import '../material-icon/material-icon';
import '../google-apis/google-maps-api.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-map-icons/katapult-map-icons.js';
import '../resizeable-div/resizeable-div.js';

/* Style Modules */
import '../style-modules/katapult-scrollbars.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-dialog-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../style-modules/flex.js';

/* Modules */
import { GetMainPhoto } from '../../modules/GetMainPhoto.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
import { FirebaseEncode } from '../../modules/FirebaseEncode.js';
import { GetJobData } from '../../modules/GetJobData.js';
import { PickAnAttribute } from '../../modules/PickAnAttribute.js';
import { SortedKeys } from '../../modules/SortedKeys.js';
import { Round } from '../../modules/Round.js';
import { CompareArrays } from '../../modules/CompareArrays.js';
import { FormatHeight } from '../../modules/FormatHeight.js';
import { AssociatePhotos } from '../../modules/AssociatePhotos.js';
import { GeofireTools } from '../../modules/GeofireTools.js';
import { GoogleGeometry } from '../../modules/GoogleGeometry.js';
import { IncrementFolderCounter } from '../../modules/IncrementFolderCounter.js';
import { DataViews } from '../../modules/DataViews.js';
import { CamelCase } from '../../modules/CamelCase.js';
import { ModelDefaults } from '../../modules/ModelDefaults.js';
import { ParseHeight } from '../../modules/FormatHeight.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import { KLogic } from '../../modules/KLogic.js';
import { TraverseMarkers } from '../../modules/TraverseMarkers.js';
import { Path } from '../../modules/Path.js';

/* global Polymer, k, firebase, ObjectObserver, calibratePhoto, Image, Blob, Buffer, atob */
class PhotoFirst extends mixinBehaviors([DefaultComputedBindings], KatapultPageElement) {
  static get template() {
    return html`
      <style include="flex paper-dialog-style paper-tooltip-style paper-menu-button-style">
        :host {
          float: left;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          --primary-color: #003e51;
          -webkit-user-select: none;
        }
        [hidden] {
          display: none !important;
        }
        /*scrollbar styles:*/
        ::-webkit-scrollbar {
          width: 10px;
          height: 10px;
        }

        ::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 3px #717271;
        }

        ::-webkit-scrollbar-thumb {
          background: var(--paper-grey-400);
        }
        /*end scrollbar styles*/
        #toast {
          white-space: nowrap;
          max-width: initial !important;
        }
        #menuButton {
          display: inline-block;
          vertical-align: middle;
        }
        #libraryToast span {
          max-width: calc(100%-96px);
          display: inline-block;
          margin-right: 24px;
          vertical-align: middle;
        }
        #menuButton {
          margin-top: 5px;
        }
        #jobChooser {
          width: 300px;
        }
        #pageElements {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          display: flex;
        }
        #main {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        #photoData {
          display: flex;
          flex-direction: column;
          height: 100%;
        }
        .mainPhotoContainer {
          border: none;
          width: 100%;
          height: 100%;
        }

        katapult-photo-chooser {
          z-index: 100;
        }

        .fitParent {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
        }

        .photos .sidePhotoContainer {
          position: absolute;
          border: none;
          top: 50%;
          z-index: 1;
          width: 120px;
          height: 200px;
          margin-top: -100px;
          cursor: pointer;
          transition: box-shadow 0.3s;
          overflow: hidden;
          @apply --shadow-elevation-2dp;
        }

        .photos .sidePhotoContainer:hover {
          @apply --shadow-elevation-4dp;
        }

        .photos .sidePhotoContainer.left {
          left: 0;
          border-top-right-radius: 999px;
          border-bottom-right-radius: 999px;
        }

        .photos .sidePhotoContainer.right {
          right: 0;
          border-top-left-radius: 999px;
          border-bottom-left-radius: 999px;
        }

        .leftRightIcon {
          top: 50%;
          color: white;
          filter: drop-shadow(0 0 1px black);
          height: 120px;
          width: 120px;
          margin-top: -60px;
          opacity: 0.6;
        }

        #photoLeft .leftRightIcon {
          right: 50%;
          margin-left: 48px;
        }

        #photoRight .leftRightIcon {
          left: 50%;
          margin-left: -48px;
        }

        #photoList {
          /* This is much bigger than necessary to account for avatars.  Overflow would not work in this case because overflow-x has to be set to auto which sets overflow-y to auto, also. */
          display: flex;
          flex-shrink: 0;
          height: 40px;
          width: 100%;
          overflow-x: auto;
          overflow-y: hidden;
          background-color: white;
          @apply --shadow-elevation-2dp;
          z-index: 3;
        }

        #photoList.hasScrollBar {
          /* Height + 17 */
          height: 57px;
        }

        #photoListPhotos {
          display: flex;
          flex-grow: 1;
          box-sizing: border-box;
        }

        .progressItem {
          position: relative;
          flex-grow: 1;
          background-color: var(--paper-grey-200);
          min-width: 10px;
          pointer-events: auto;
          border-radius: 3px 3px 0 0;
        }
        .progressItem:not(:last-of-type) {
          margin-right: 1px;
        }
        .progressItem:hover {
          background-color: var(--paper-yellow-500) !important;
          border-color: var(--paper-yellow-700) !important;
          cursor: pointer;
        }
        #selectedPhotoCounter {
          position: absolute;
          right: 8px;
          bottom: 60px;
          display: flex;
          align-items: center;
          border-radius: 48px;
          z-index: 999;
          background-color: var(--secondary-color);
          color: var(--secondary-color-text-color);
          padding: 8px;
        }
        #selectedPhotoCounter katapult-button[iconOnly] {
          padding: 0;
          width: 24px;
        }
        #deselectPhotosButton {
          margin-right: 5px;
        }
        #dialogMenuButton {
          position: relative;
          margin-top: 0;
          margin-right: 0;
        }
        #morePhotoOptions {
          padding: 0 0 0 10px;
        }
        #morePhotoOptions iron-icon {
          margin-right: 10px;
        }
        #morePhotoOptions paper-item {
          white-space: nowrap;
          padding: 0 16px !important;
          color: var(--primary-text-color);
        }
        #morePhotoOptions paper-item iron-icon {
          color: var(--primary-text-color-faded);
        }
        #morePhotoOptions paper-item:hover {
          background-color: var(--secondary-color);
          color: var(--secondary-color-text-color);
        }
        #morePhotoOptions paper-item:hover iron-icon {
          color: var(--secondary-color-text-color);
        }
        #dragImageContainer {
          position: fixed;
          top: 100%;
          left: 100%;
        }
        .dragImage {
          background-color: #3f51b5;
          border: 2px solid #3f51b5;
          padding: 5px;
          color: white;
          display: inline-block;
          white-space: nowrap;
          border-radius: 3px;
        }
        paper-toast {
          max-width: 33%;
        }

        .toastButton {
          color: black;
          background-color: #eeff41;
        }

        .chromeDrawing {
          cursor:
            url('data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBvbHlnb24gcG9pbnRzPSIwLDEzIDExLDEzIDExLDI0IDEzLDI0IDEzLDEzIDI0LDEzIDI0LDExIDEzLDExIDEzLDAgMTEsMCAxMSwxMSAwLDExIDAsMTMiIHN0eWxlPSJmaWxsOiNGRjgzMDA7c3Ryb2tlOmJsYWNrO3N0cm9rZS13aWR0aDowLjVweDsiLz4KPC9zdmc+')
              12 12,
            auto;
        }

        .drawing {
          cursor: crosshair;
        }
        #photoLabel {
          position: absolute;
          pointer-events: none;
          width: 150px;
          text-align: center;
          left: 50%;
          margin-left: -75px;
          top: 0;
          z-index: 3;
          font-size: 12pt;
          background-color: rgba(255, 255, 255, 0.7);
          word-wrap: break-word;
          transition: height 0.18s ease-in-out;
          overflow: hidden;
        }

        #warningsDialog {
          height: 500px;
          width: 400px;
        }
        #warningsDialog div.warningsDialogHeaderSection {
          display: flex;
          flex-direction: row;
        }
        #warningsDialog div.warningsDialogHeaderSection .warningsDialogHeader {
          flex-grow: 1;
          margin-top: 3px;
        }
        #warningsDialog div.warningsDialogHeaderSection .warningsDialogCloseButton {
          top: -6px;
        }

        #photoCount {
          display: flex;
          white-space: nowrap;
          align-items: center;
          border-radius: 80px;
          background-color: var(--secondary-color);
          color: var(--secondary-color-text-color);
          padding: 4px 12px;
          justify-self: flex-end;
          font-size: 11pt;
        }
        .helpLink {
          position: absolute;
          left: -23px;
          top: 5px;
        }
        #multipleAssociatedNodes {
          background-color: white;
        }
        .photos .mainPhotoContainer {
          --annotation-editor: {
            top: 4em;
            transition: top ease-in-out 0.3s;
          };
        }
        #photoContainer {
          position: relative;
          flex-grow: 1;
          min-height: 0;
        }
        .trace #photoContainer,
        .upshot #photoContainer,
        .cuEntry #photoContainer,
        .transferHeights #photoContainer,
        .pci #photoContainer {
          display: flex;
          height: 100%;
        }
        .trace #photoControls,
        .upshot #photoControls,
        .cuEntry #photoControls,
        .transferHeights #photoControls,
        .pci #photoControls {
          display: flex;
          flex-grow: 1;
        }
        .cuEntry #photoControls,
        .pci #photoControls {
          width: 100%;
        }
        .upshot #upshotMeasurement,
        .cuEntry #cuEntry,
        .pci #pci {
          flex-grow: 2;
        }
        .trace .mainPhotoContainer,
        .upshot .mainPhotoContainer,
        .cuEntry .mainPhotoContainer,
        .cuEntry .transferHeights {
          flex-grow: 1;
          /*margin-left:33%;*/
          height: 100%;
        }
        .upshot .mainPhotoContainer {
          position: relative;
        }
        .sidePhotoContainer {
          top: 0;
          margin-top: 0;
          height: 100%;
          position: relative;
          flex-grow: 1;
          cursor: default;
        }
        .trace #photoList,
        .trace #photoListPhotos,
        .trace .hasScrollBar,
        .trace #photoLabel,
        .upshot #photoList,
        .upshot #photoListPhotos,
        .cuEntry #photoList,
        .cuEntry #photoListPhotos,
        .transferHeights #photoList,
        .transferHeights #photoListPhotos,
        .pci #photoList,
        .pci #photoListPhotos {
          height: 0;
        }
        .disclaimerSpacer {
          height: 20px;
        }
        #infoPanel {
          position: absolute;
          overflow: hidden;
          height: 100%;
          width: 340px;
          top: 0;
          right: -360px;
          z-index: 3;
          box-sizing: border-box;
          transform-origin: right;
          transform: translateX(0px);
          transition: -webkit-transform 0.3s;
          background-color: white;
          -webkit-user-select: text;
          user-select: text;
          @apply --shadow-elevation-4dp;
          overflow-y: auto;
        }
        #infoPanel.open {
          transform: translateX(-340px);
        }
        #infoPanel .title {
          display: block;
          @apply --paper-font-title;
        }
        #infoPanel h2,
        #infoPanel a {
          margin: 6px;
        }
        #infoPanel .infoItem {
          align-items: center;
          margin: 12px;
          margin-left: 20px;
          text-align: left;
          display: flex;
        }
        #infoPanelHeader {
          width: 100%;
          padding: 20px;
          margin-bottom: 6px;
        }
        .infoLabel {
          color: var(--paper-grey-700);
          margin-right: 12px;
        }
        #fullscreenPhoto {
          position: fixed;
          width: 100%;
          height: 100%;
          z-index: 1001;
          overflow: hidden;
          --iron-overlay-backdrop-background-color: #fff;
          --iron-overlay-backdrop-opacity: 1;
        }
        #fullscreenPhoto katapult-photo-viewer {
          width: 100%;
          height: 100%;
        }
        #closeFullscreenPhoto {
          position: absolute;
          top: 1em;
          left: 1em;
          z-index: 2;
          border-radius: 100%;
        }
        #fullPhotoLeft {
          position: absolute;
          left: 1px;
          top: 50%;
          margin-top: -20px;
          border-radius: 0 1000px 1000px 0;
        }
        #fullPhotoRight {
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -20px;
          border-radius: 1000px 0 0 1000px;
        }
        .mainPhotoContextMenuTrayContainer {
          position: absolute;
          bottom: 10px;
          left: 10px;
          width: calc(100% - 20px);
          display: flex;
          justify-content: center;
          z-index: 2;
        }
        .mainPhotoContextMenuTray {
          display: flex;
          justify-content: space-around;
          width: inherit;
          text-align: center;
          align-items: center;
          max-width: 420px;
          padding: 4px;
          border-radius: 4px;
          color: white;
          background-color: #212121;
        }
        .mainPhotoContextMenuPaperInput {
          display: inline-block;
          width: 60px;
          text-align: center;
          --paper-input-container: {
            margin-top: -20px;
          };
          --paper-input-container-input-color: white;
          --paper-input-container-focus-color: white;
        }
        .mainPhotoContextMenuPaperButtonConfirm {
          color: white;
          margin: 0;
          background-color: #3f51b5;
        }
        @media all and (min-width: 601px) {
          paper-dialog {
            width: 600px;
          }
        }
        .insertBlankButton {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 3;
          width: 140px;
          text-align: center;
          background: #007299;
          color: white;
          margin: 0;
        }
        .insertBlankButtonContainer {
          position: relative;
          width: 140px;
        }
        .blankItemLabel {
          position: absolute;
          top: 50%;
          text-align: center;
        }
        #cameraCalibrationInputs {
          position: absolute;
          top: 50px;
          z-index: 4;
          width: 300px;
          margin: 20px;
          background-color: white;
          padding: 10px;
          border-radius: 5px;
          box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
        }
        #cameraCalibrationInputs paper-input {
          width: 75px;
          margin: 0 5px;
          text-align: center;
        }
        #cameraCalibrationDialog {
          display: flex;
          flex-direction: column;
        }
        .messageOverlay {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          font-size: 24pt;
          color: #7a7a7a;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          font-family: Roboto;
        }
        .messageOverlay.hide {
          opacity: 0;
          transition: none;
        }
        .messageOverlay.show {
          opacity: 1;
          transition: opacity 0.3s ease 2s;
        }
        #stateButtons {
          white-space: nowrap;
        }
        #stateButtons > * {
          transition: all 0.1s;
          margin: 4px;
        }
        #stateButtons > *:hover {
          background-color: var(--paper-grey-100);
        }
        .findInMapsButton {
          background-color: var(--paper-cyan-500);
        }
        avatar-icon {
          z-index: 3;
        }
        #transferHeightsPrompt {
          z-index: 4;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          background-color: var(--paper-grey-300);
          padding: 20px;
          position: absolute;
          bottom: 0;
          left: 100px;
        }
        paper-input,
        paper-textarea {
          --primary-color: var(--secondary-color);
        }
        .buttons {
          gap: 8px;
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
      </style>
      <!-- Firebase Data-->
      <model-loader
        company-id="[[jobCreator]]"
        items='["attributes", "input_models", "routines", "input_model_groups", "trace_models", "config/photofirst", "alternate_designs", "config/defaults"]'
        other-attributes="{{otherAttributes}}"
        input-models="{{inputModels}}"
        routines="{{routines}}"
        input-model-groups="{{inputModelGroups}}"
        trace-models="{{traceModels}}"
        config-photofirst="{{modelConfig}}"
        alternate-designs="{{alternateDesignsConfig}}"
        config-defaults="{{configDefaults}}"
      >
      </model-loader>
      <firebase-document
        id="jobCreatorID"
        path="photoheight/jobs/{{jobId}}/job_creator"
        data="{{jobCreator}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="projectId"
        path="photoheight/jobs/[[jobId]]/project_id"
        data="{{projectId}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-query
        id="avatars"
        path="photoheight/company_space/{{userGroup}}/avatars/photos"
        data="{{avatars}}"
        order-by-child="job_id"
        equal-to="[[jobId]]"
        disabled="[[!and(signedIn, photoSummaryRequired)]]"
      ></firebase-query>
      <firebase-document
        id="userData"
        path="photoheight/company_space/{{userGroup}}/user_data/{{user.uid}}"
        data="{{userData}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="users"
        path="photoheight/company_space/{{userGroup}}/users"
        data="{{users}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="userModules"
        path="photoheight/company_space/[[userGroup]]/subscription/modules"
        data="{{userModules}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="_editors"
        path="photoheight/jobs/[[jobId]]/photos/[[photo]]/photofirst_data/_editors"
        data="{{_editors}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="proposedCableLogic"
        path="{{getModelsUrl(userGroup, jobId, jobCreatorChanged, 'make_ready/proposed_cable_logic')}}"
        data="{{proposedCableLogic}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-query
        id="makeReadyClearances"
        path="{{getModelsUrl(userGroup, jobId, jobCreatorChanged, 'make_ready/make_ready_items')}}"
        order-by-child="order"
        data="{{makeReadyClearances}}"
        disabled="[[!signedIn]]"
      ></firebase-query>
      <firebase-document
        id="tier"
        path="photoheight/company_space/[[or(jobCreator, userGroup)]]/tier"
        data="{{tier}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="jobStyles"
        path="photoheight/jobs/{{jobId}}/map_styles"
        data="{{jobStyles}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="metadata"
        path="photoheight/jobs/{{jobId}}/metadata"
        data="{{metadata}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="attacherName"
        path="utility_info/[[config.firebaseData.utilityCompany]]/attachers/[[metadata.attachment_owner]]/name"
        data="{{attacherName}}"
      ></firebase-document>
      <firebase-document
        id="connection"
        path="photoheight/jobs/{{jobId}}/connections/{{traceConnectionId}}"
        data="{{connection}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="rootCompany"
        path="user_groups/{{user.uid}}/root_company"
        data="{{rootCompany}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="node1"
        path="photoheight/jobs/{{jobId}}/nodes/{{node1Id}}"
        data="{{node1}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="node2"
        path="photoheight/jobs/{{jobId}}/nodes/{{node2Id}}"
        data="{{node2}}"
        disabled="[[!signedIn]]"
      ></firebase-document>
      <firebase-document
        id="photoSummary"
        path="photoheight/jobs/[[jobId]]/photo_summary"
        data="{{photoSummary}}"
        disabled="[[!and(signedIn, photoSummaryRequired)]]"
      ></firebase-document>
      <firebase-query
        id="collectionSets"
        path="photoheight/jobs/[[jobId]]/photo_folders"
        data="{{collectionSets}}"
        disabled="[[!signedIn]]"
      ></firebase-query>
      <katapult-firebase-worker
        id="sharing"
        path="photoheight/jobs/[[jobId]]/sharing/[[userGroup]]"
        data="{{sharing}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        id="jobStatus"
        path="photoheight/jobs/[[jobId]]/status"
        data="{{jobStatus}}"
        disabled="[[!signedIn]]"
      ></katapult-firebase-worker>
      <template is="dom-if" if="[[enabledFeatures.sag_calculation_view]]">
        <katapult-firebase-worker
          id="sagData"
          data="{{sagData}}"
          path="photoheight/company_space/[[userGroup]]/models/sag_data"
        ></katapult-firebase-worker>
        <katapult-firebase-worker
          id="proposedSagData"
          data="{{proposedSagData}}"
          path="photoheight/company_space/[[userGroup]]/models/proposed_sag_data"
        ></katapult-firebase-worker>
      </template>

      <google-maps-api api-key="[[config.mapsApiKey]]" channel="[[userGroup]]"></google-maps-api>
      <katapult-map-icons></katapult-map-icons>

      <iron-localstorage name="connectedPhotoList" value="{{connectedPhotoList}}"></iron-localstorage>
      <project-folder-chooser
        id="projectFolderChooser"
        user-group="{{userGroup}}"
        disabled="[[!signedIn]]"
        on-toast="displayToastMessage"
      ></project-folder-chooser>
      <iron-a11y-keys target="{{getItemById('photoControls')}}" keys="left right" on-keys-pressed="setPictureLeftRight"></iron-a11y-keys>
      <iron-a11y-keys target="{{getItemById('photoControls')}}" keys="ctrl+k meta+k" on-keys-pressed="calibrateCamera"></iron-a11y-keys>
      <!-- <iron-a11y-keys target="{{getItemById('photoControls')}}" keys="home" on-keys-pressed="zoomMap"></iron-a11y-keys> -->

      <!--Fullscreen Photo Dialog-->
      <iron-overlay-backdrop
        tabindex="-1"
        id="fullscreenPhoto"
        entry-animation="scale-up-animation"
        layered="false"
        always-on-top=""
        auto-fit-on-attach=""
      >
        <!-- tabindex allows this element to be focused using .focus().  This allows katapult-photo-viewer to put focus back to this element so keyboard events work. -->
        <iron-a11y-keys keys="esc" on-keys-pressed="closeFullscreenPhoto" stopkeyboardeventpropagation=""></iron-a11y-keys>
        <katapult-button id="closeFullscreenPhoto" icon="close" iconOnly noBorder on-click="closeFullscreenPhoto"></katapult-button>
        <katapult-photo-viewer
          photo-data="{{of(fullscreenPhotos, fullscreenPhoto, 'photoData')}}"
          photo-id="[[of(fullscreenPhotos, fullscreenPhoto, 'photoId')]]"
          src="[[fullscreenPhotoSrc]]"
          in-extraction-loop="{{inExtractionLoop}}"
          disabled="[[!signedIn]]"
          use-metric-units="[[userData.use_metric_units]]"
          use-decimal-feet="[[userData.use_decimal_feet]]"
          zoom=""
          scroll-sensitivity="[[scrollSensitivity]]"
          published="[[locked]]"
          input-model-group-keys="[[inputModelGroupKeys]]"
          input-model-group-key="{{inputModelGroup}}"
          has-make-ready-rules="[[!equal(makeReadyClearances.length, 0)]]"
          sag-data="[[sagData]]"
          proposed-sag-data="[[proposedSagData]]"
        ></katapult-photo-viewer>
        <template is="dom-if" if="[[!equal(fullscreenPhoto, null)]]">
          <iron-a11y-keys keys="left" on-keys-pressed="switchFullPhotoLeft"></iron-a11y-keys>
          <iron-a11y-keys keys="right" on-keys-pressed="switchFullPhotoRight"></iron-a11y-keys>
          <katapult-button id="fullPhotoLeft" icon="chevron_left" iconOnly noBorder on-click="switchFullPhotoLeft"></katapult-button>
          <katapult-button id="fullPhotoRight" icon="chevron_right" iconOnly noBorder on-click="switchFullPhotoRight"></katapult-button>
        </template>
      </iron-overlay-backdrop>

      <paper-toast id="toast" duration="6000"></paper-toast>
      <katapult-auth
        user="{{user}}"
        company="{{company}}"
        user-group="{{userGroup}}"
        signed-in="{{signedIn}}"
        read-only="{{readOnlyUser}}"
        title="[[config.firebaseData.name]] Photos"
        signup-link="https://katapultpro.com/signup"
        no-signup="[[!config.firebaseData.offerLicenses]]"
      >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] Maps</p>
        </div>
        <div slot="description-content">
          <p>[[config.firebaseData.name]] Maps allows you to design and share survey jobs with Maps and Photos from any computer.</p>
          <p>Gather data for a permanent record of real-world conditions in minutes!</p>
          <template is="dom-if" if="{{appNameContains(config.firebaseData.name, 'katapult')}}">
            <p>
              Need some help? View our
              <a href="https://katapultpro.com/help/" style="color: white; font-weight: normal; text-decoration: none;">Docs</a>
            </p>
          </template>
        </div>

        <div id="main" slot="auth-content">
          <replace-action-dialog user-group="[[userGroup]]"></replace-action-dialog>
          <paper-dialog id="unknownWarnings" no-cancel-on-outside-click="">
            <h2>Please fix the following items before continuing:</h2>
            <ul>
              <template is="dom-repeat" items="{{midspanWarnings}}" as="warning">
                <li>{{warning}}</li>
              </template>
            </ul>
            <div class="buttons">
              <katapult-button color="var(--secondary-color)" dialog-confirm>Ok</katapult-button>
            </div>
          </paper-dialog>

          <!-- Basic Warnings Dialog -->
          <paper-dialog
            id="warningsDialog"
            horizontal-align="left"
            vertical-align="bottom"
            entry-animation="scale-up-animation"
            exit-animation="fade-out-animation"
            no-cancel-on-esc-key=""
            no-cancel-on-outside-click=""
          >
            <div class="warningsDialogHeaderSection">
              <h2 class="warningsDialogHeader">{{warningsDialogDataTitle}}</h2>
              <katapult-button class="warningsDialogCloseButton" icon="close" iconOnly noBorder dialog-dismiss></katapult-button>
            </div>
            <!--Any summary text-->
            <p>{{warningsDialogDataSummary}}</p>
          </paper-dialog>

          <!-- Camera Calibration Distortion Value Dialog-->
          <paper-dialog id="cameraCalibrationDialog">
            <h2>Choose Focal Lengths to Test Distortion Values</h2>
            <paper-dialog-scroll>
              <template is="dom-repeat" items="{{focalLengthsToTest}}" as="focalLength">
                <paper-checkbox id="{{focalLength}}" style="margin-left:15px;">{{focalLength}}</paper-checkbox>
              </template>
            </paper-dialog-scroll>
            <div class="buttons">
              <katapult-button on-click="closeCameraCalibrationDialog">Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" on-click="tryNewDistortionValues" dialog-dismiss>Try Values</katapult-button>
            </div>
          </paper-dialog>

          <!-- Inputs for Camera Calibration -->
          <template is="dom-if" if="{{calibratingCamera}}">
            <div id="cameraCalibrationInputs">
              Enter range and amount to increment by:
              <div style="display:flex;margin-left:51px;margin-right:25px;margin-top:5px;justify-content:space-around;">
                <span>a</span>
                <span>b</span>
                <span>c</span>
              </div>
              <paper-item
                >max
                <paper-input id="aMaxInput" value="{{aMax}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="bMaxInput" value="{{bMax}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="cMaxInput" value="{{cMax}}" type="number" no-label-float="" required=""></paper-input>
              </paper-item>
              <paper-item
                >min
                <paper-input id="aMinInput" value="{{aMin}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="bMinInput" value="{{bMin}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="cMinInput" value="{{cMin}}" type="number" no-label-float="" required=""></paper-input>
              </paper-item>
              <paper-item
                >incr
                <paper-input id="aIncrInput" value="{{aIncr}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="bIncrInput" value="{{bIncr}}" type="number" no-label-float="" required=""></paper-input>
                <paper-input id="cIncrInput" value="{{cIncr}}" type="number" no-label-float="" required=""></paper-input>
              </paper-item>
              <paper-input label="Heights to use for error" style="width:285px;" value="{{heightsToUse}}"></paper-input>
              <paper-checkbox style="margin:5px 0;" checked="{{useAveragePhotoError}}">Use Average Photo Error</paper-checkbox>
              <paper-checkbox style="margin:5px 0;" checked="{{stickHeightsOnly}}">Stick Heights Only</paper-checkbox>
              <div class="buttons" style="display:flex;justify-content:flex-end;">
                <katapult-button on-click="resetCalibrationValues">Reset</katapult-button>
                <katapult-button color="var(--secondary-color)" on-click="loopCalibration">Estimate Values</katapult-button>
              </div>
              <div>
                <paper-item>
                  <paper-checkbox id="useSetValues" checked="{{useSetValues}}" style="width:100px">Use Set Values</paper-checkbox>
                  <paper-input id="aSetInput" placeholder="a" value="{{aSet}}" type="number" no-label-float="" required=""></paper-input>
                  <paper-input id="bSetInput" placeholder="b" value="{{bSet}}" type="number" no-label-float="" required=""></paper-input>
                  <paper-input id="cSetInput" placeholder="c" value="{{cSet}}" type="number" no-label-float="" required=""></paper-input>
                </paper-item>
              </div>
            </div>
          </template>
          <!--New Data Item-->
          <div id="photoData" class$="{{view}}">
            <!--Current Photo Name and Time -->
            <template is="dom-if" if="{{equal(view, 'photos')}}">
              <div id="photoLabel">{{getPhotoName(photo, mainPhotoDataLoaded)}}<br />{{getSyncedTime(photo, mainPhotoDataLoaded)}}</div>
            </template>
            <katapult-toolbar
              style="flex-shrink: 0; z-index: 4;"
              user-group="[[userGroup]]"
              job-id="[[jobId]]"
              job-creator="[[jobCreator]]"
              project-id="[[projectId]]"
            >
              <job-chooser
                id="jobChooser"
                slot="left"
                selected="{{jobId}}"
                user-group="{{userGroup}}"
                job-name="{{jobName}}"
                on-toast="displayToastMessage"
                select-on-focus=""
                firebase-disabled="[[!signedIn]]"
              >
              </job-chooser>
              <paper-menu-button id="collectionSetSwitcher" slot="left" vertical-offset="56">
                <katapult-button icon="photo_library" iconOnly noBorder slot="dropdown-trigger"></katapult-button>
                <paper-listbox slot="dropdown-content">
                  <template is="dom-repeat" items="[[collectionSets]]">
                    <dom-bind
                      item="[[item]]"
                      bound-get-collection-set-name="[[boundGetCollectionSetName]]"
                      bound-update-filtered-collection-sets="[[boundUpdateFilteredCollectionSets]]"
                      bound-get-collection-set-active="[[boundGetCollectionSetActive]]"
                    >
                      <template>
                        <paper-item style="padding: 0 20px;">
                          <paper-checkbox
                            checked="[[boundGetCollectionSetActive(item.$key)]]"
                            collection-set-id="[[item.$key]]"
                            on-click="boundUpdateFilteredCollectionSets"
                            >[[boundGetCollectionSetName(item)]]</paper-checkbox
                          >
                        </paper-item>
                      </template>
                    </dom-bind>
                  </template>
                </paper-listbox>
              </paper-menu-button>
              <paper-tooltip for="collectionSetSwitcher" slot="left">Collection Sets</paper-tooltip>
              <template is="dom-if" if="{{equal(view, 'photos')}}">
                <katapult-button
                  id="selectAllPhotos"
                  slot="left"
                  icon="select_all"
                  iconOnly
                  noBorder
                  on-click="selectAllPhotos"
                ></katapult-button>
                <paper-tooltip for="selectAllPhotos" slot="left">Select All Photos</paper-tooltip>
              </template>
              <div slot="left" style="flex-grow: 1;"></div>
              ]
              <template is="dom-if" if="[[isView(view, 'photos')]]">
                <template is="dom-if" if="[[!nothingSelected]]">
                  <div id="photoCount" slot="center" hidden="{{nothingSelected}}">
                    <span>Image [[getPhotoCount(photo, filteredPhotoKeys, filteredPhotoKeys.length)]] of [[filteredPhotoKeys.length]]</span>
                  </div>
                </template>
              </template>
              <template is="dom-if" if="[[isView(view, 'trace')]]">
                <katapult-button id="swapPhotos" icon="swap_horiz" on-click="reversePhotoOrder" color="var(--secondary-color)" slot="center"
                  >Swap Photos</katapult-button
                >
                <paper-tooltip for="swapPhotos" slot="center" offset="4">Swap order of photos horizontally</paper-tooltip>
              </template>
              <!-- Right Slot Content -->
              <div id="stateButtons" slot="right">
                <katapult-button
                  id="sagViewButton"
                  name="sagView"
                  icon="call_missed_outgoing"
                  iconOnly
                  noBorder
                  noBackground
                  on-click="toggleShowSag"
                  text-color="[[if(showSag, 'var(--paper-green-500)', '')]]"
                  hidden$="[[!enabledFeatures.sag_calculation_view]]"
                ></katapult-button>
                <paper-tooltip for="sagViewButton">Sag Calculation View</paper-tooltip>
                <katapult-button
                  id="mrViewButton"
                  name="mrView"
                  icon="format_line_spacing"
                  iconOnly
                  noBorder
                  text-color="[[if(showClearances, 'var(--paper-green-500)', '')]]"
                  on-click="toggleShowClearances"
                  hidden$="[[equal(makeReadyClearances.length, 0)]]"
                ></katapult-button>
                <paper-tooltip for="mrViewButton">Make Ready View</paper-tooltip>
                <katapult-button
                  id="editLockButton"
                  name="lock"
                  icon="[[if(locked, 'lock', 'lock_open')]]"
                  iconOnly
                  noBorder
                  text-color="[[if(locked, 'var(--paper-red-500)', '')]]"
                  on-click="toggleLocked"
                ></katapult-button>
                <paper-tooltip for="editLockButton">Read Only Mode</paper-tooltip>
                <katapult-button
                  id="cableTraceButton"
                  name="cableTrace"
                  icon="view_week"
                  iconOnly
                  noBorder
                  text-color="[[if(cableTracing, 'var(--paper-blue-500)', '')]]"
                  on-click="toggleCableTracing"
                  active$="[[!locked]]"
                ></katapult-button>
                <paper-tooltip for="cableTraceButton">Cable Trace View</paper-tooltip>
              </div>
              <div slot="right" style="flex-grow: 1;"></div>
            </katapult-toolbar>
            <div id="photoContainer" style="flex-grow: 1;" tabindex="0" class$="{{photoListClasses}}">
              <template is="dom-if" if="{{nothingSelected}}">
                <div class="messageOverlay">
                  <div>
                    <iron-icon icon="image:photo-library" style="width: 80px; height: 80px; margin-right: 1em;"></iron-icon>Select a Job to
                    get started
                  </div>
                </div>
              </template>
              <div class$="messageOverlay hide {{showNoPhotosMessage(noPhotos, nothingSelected, 'show')}}">
                <div><iron-icon icon="image:photo-library" style="width: 80px; height: 80px; margin-right: 1em;"></iron-icon>No Photos</div>
              </div>
              <photo-controls
                id="photoControls"
                view="{{view}}"
                mode="{{mode}}"
                job-id="[[jobId]]"
                job-styles="[[jobStyles]]"
                job-creator="[[jobCreator]]"
                user-data="[[userData]]"
                show-sag="[[showSag]]"
                show-clearances="{{showClearances}}"
                mr-clearances="[[getItemById('makeReadyClearances')]]"
                proposed-cable-logic="[[proposedCableLogic]]"
                use-metric-units="[[userData.use_metric_units]]"
                use-decimal-feet="[[userData.use_decimal_feet]]"
                smart-cursor="[[userData.smartCursor]]"
                min-search="[[userData.perfectCenterMinSearch]]"
                locked="[[locked]]"
                tier="[[tier]]"
                metadata="[[metadata]]"
                attacher-name="[[attacherName]]"
                disabled="[[!signedIn]]"
                model-config="{{modelConfig}}"
                user-group="{{userGroup}}"
                uid="{{user.uid}}"
                photo="[[photo]]"
                input-model-group="[[inputModelGroup]]"
                in-extraction-loop="{{inExtractionLoop}}"
                input-model-groups="[[inputModelGroups]]"
                input-models="[[inputModels]]"
                trace-models="{{traceModels}}"
                other-attributes="[[otherAttributes]]"
                routines="[[routines]]"
                trace-listeners="{{traceListeners}}"
                show-one-click-menu="{{userData.show_one_click_menu}}"
                right-click-one-click-menu="{{userData.right_click_one_click_menu}}"
                default-power-company="{{defaultPowerCompany}}"
                default-company="{{defaultCompany}}"
                allow-three-align-points="{{allowThreeAlignPoints}}"
                user-modules="[[userModules]]"
                on-toast="displayToastMessage"
                on-get-diameter="carryAttributes"
                on-mark-connection-tracing-complete="markConnectionTracingComplete"
                on-photo-library-add="photoLibraryAdd"
                on-photo-library-trigger="togglePhotoChooser"
                _editors="{{_editors}}"
                photo-left="[[photoLeft]]"
                photo-right="[[photoRight]]"
                on-advance-photo="setPictureLeftRight"
                model-defaults="[[modelDefaults]]"
                dragging="[[dragging]]"
              >
                <!--Photo Left-->
                <resizeable-div
                  class="sidePhotoContainer left"
                  left
                  right
                  hidden$="[[!calcShowViewer('left', photoLeft, view)]]"
                  disabled="[[disableManualPhotoResize]]"
                >
                  <template is="dom-if" if="{{equal(view, 'trace')}}">
                    <katapult-photo-chooser
                      job-id="[[jobId]]"
                      name="node"
                      uid="{{user.uid}}"
                      user-group="{{userGroup}}"
                      tier="[[tier]]"
                      use-metric-units="[[userData.use_metric_units]]"
                      use-decimal-feet="[[userData.use_decimal_feet]]"
                      class="fitParent"
                      item="{{leftNode}}"
                      selected="{{photoLeft}}"
                      on-chooser-select="chooserSelect"
                      on-chooser-photo-tap="openPhoto"
                      on-open-transfer-heights="openTransferHeights"
                      model-config="{{modelConfig}}"
                    ></katapult-photo-chooser>
                  </template>
                  <katapult-photo-viewer
                    id="photoLeft"
                    annotation-editor-show-menu="{{annotationEditorShowMenu}}"
                    item="{{leftNode}}"
                    in-extraction-loop="{{inExtractionLoop}}"
                    visible-buttons="{{getVisibleButtons(leftNode, 'true', 'photoLeft', modelConfig.*, tier, view, locked, showClearances, userGroup, alternateDesignsConfig, enabledFeatures.*)}}"
                    class$="{{getDrawingClass(mode, view)}} fitParent tracingPhoto"
                    allow-tracing="{{isTracing(leftNode.nodeId, view, photoLeft)}}"
                    use-metric-units="[[userData.use_metric_units]]"
                    use-decimal-feet="[[userData.use_decimal_feet]]"
                    load-data
                    disabled="[[!signedIn]]"
                    photo-association="[[getPhotoAssociation(leftNode)]]"
                    zoom="{{isView(view, 'trace', 'transferHeights', 'pci')}}"
                    scroll-sensitivity="[[scrollSensitivity]]"
                    annotations="{{showAnnotations(view, showLines, 'left')}}"
                    on-exit-view="exitView"
                    on-open-upshot-view="openUpshotView"
                    show-clearances="{{showClearances}}"
                    config="{{modelConfig}}"
                    name$="{{photoLeft}}"
                    photo-id="{{photoLeft}}"
                    use-lazy-loading
                    photo-data="{{photoLeftData}}"
                    job-id="{{jobId}}"
                    job-styles="[[jobStyles]]"
                    input-models="{{inputModels}}"
                    input-model-group="{{of(inputModelGroups, inputModelGroup)}}"
                    other-attributes="[[otherAttributes]]"
                    user-group="{{userGroup}}"
                    on-click="setPictureLeftRight"
                    on-reload-urls="reloadJobUrls"
                    tabindex="0"
                    auto-resize
                    trace-listeners="{{traceListeners}}"
                    single-click-list="{{singleClickList}}"
                    mode="{{mode}}"
                    uid="{{user.uid}}"
                    on-open-chooser="openChooser"
                    job-creator="[[jobCreator]]"
                    on-photo-library-trigger="togglePhotoChooser"
                    on-zoomed="calcChooserScale"
                    users="[[users]]"
                    user-modules="[[userModules]]"
                    make-ready-clearances="[[getItemById('makeReadyClearances')]]"
                    has-make-ready-rules="[[!equal(makeReadyClearances.length, 0)]]"
                    distance-ratios="[[ifPci(pciDistanceRatios)]]"
                    job-creator="[[jobCreator]]"
                    left-photo-id="[[ifPci(leftNodePhotoId)]]"
                    right-photo-id="[[ifPci(rightNodePhotoId)]]"
                    default-power-company="[[defaultPowerCompany]]"
                    default-company="[[defaultCompany]]"
                    disclaimer-exists="{{leftDisclaimer}}"
                    no-fit="[[equal(view, 'photos')]]"
                    toolbar="[[isView(view, 'trace', 'pci')]]"
                    toolbar-is-hidden="{{toolbarIsHidden}}"
                    toolbar-height="{{toolbarHeight}}"
                    on-enable-make-ready="enableMakeReady"
                    on-open-photo="openPhoto"
                    published="[[locked]]"
                    input-model-group-keys="[[inputModelGroupKeys]]"
                    input-model-group-key="{{inputModelGroup}}"
                    on-confirm="confirmEvent"
                    alternate-designs-config="[[alternateDesignsConfig]]"
                    model-defaults="[[modelDefaults]]"
                    dragging="{{dragging}}"
                    show-warnings
                    on-marker-selected="updateThreeDViewSelectedTraceData"
                  >
                    <katapult-button icon="map" on-click="openInMaps" class="findInMapsButton" slot="toolbar-info-content"
                      >Find in Maps</katapult-button
                    >
                    <template is="dom-if" if="{{equal(view, 'trace')}}">
                      <katapult-photo-label
                        user-group="[[userGroup]]"
                        uid="[[user.uid]]"
                        company="[[jobCreator]]"
                        nodes="[[array(leftNode)]]"
                        show-clearances="{{showClearances}}"
                        slot="toolbar-label"
                        user-modules="[[userModules]]"
                      ></katapult-photo-label>
                      <!-- <div class="photoLabel" slot="toolbar-label">
                          <template is="dom-repeat" items="{{leftLabels}}">
                            <span>{{item}}</span>
                            <br />
                          </template>
                          <template is="dom-if" if="{{leftDisclaimer}}">
                            <div class="disclaimerSpacer"></div>
                          </template>
                        </div> -->
                    </template>
                    <template is="dom-if" if="{{equal(view, 'photos')}}">
                      <paper-ripple noink></paper-ripple>
                      <iron-icon class="leftRightIcon" icon="chevron-left"></iron-icon>
                    </template>
                  </katapult-photo-viewer>
                </resizeable-div>
                <template is="dom-if" if="{{!isView(view, 'upshot', 'cuEntry')}}">
                  <template is="dom-if" if="{{showBlankPhotoButton(leftNode.nodeId, view, photoLeft)}}">
                    <div class="insertBlankButtonContainer">
                      <span class="blankItemLabel">Node Without a Photo.</span>
                      <katapult-button
                        class="insertBlankButton"
                        on-click="insertBlankPhoto"
                        data-type="node"
                        data-item-id$="{{leftNode.nodeId}}"
                        >Insert Blank Photo for Measuring?</katapult-button
                      >
                    </div>
                  </template>
                </template>
                <!--Main Photo-->
                <resizeable-div class="mainPhotoContainer" left right hidden$="{{!photo}}" disabled="[[disableManualPhotoResize]]">
                  <template is="dom-if" if="{{isView(view, 'trace')}}">
                    <katapult-photo-chooser
                      job-id="[[jobId]]"
                      name="section"
                      uid="{{user.uid}}"
                      user-group="{{userGroup}}"
                      item="{{mainPhotoItem}}"
                      tier="[[tier]]"
                      use-metric-units="[[userData.use_metric_units]]"
                      use-decimal-feet="[[userData.use_decimal_feet]]"
                      class="fitParent"
                      selected="{{photo}}"
                      on-chooser-select="chooserSelect"
                      on-chooser-photo-tap="openPhoto"
                      model-config="{{modelConfig}}"
                    ></katapult-photo-chooser>
                  </template>
                  <katapult-photo-viewer
                    id="mainPhoto"
                    style$="[[getMainPhotoStyle(view)]]"
                    metadata="[[metadata]]"
                    enabled-features="[[enabledFeatures]]"
                    annotation-editor-show-menu="{{annotationEditorShowMenu}}"
                    in-extraction-loop="{{inExtractionLoop}}"
                    hidden$="{{nothingSelected}}"
                    item="{{mainPhotoItem}}"
                    left-node="{{leftNode}}"
                    right-node="{{rightNode}}"
                    visible-buttons="{{getVisibleButtons(mainPhotoItem, 'false', 'mainPhoto', modelConfig.*, tier, view, locked, showClearances, userGroup, enabledFeatures.*)}}"
                    class$="{{getDrawingClass(mode, view, 'main')}} fitParent tracingPhoto"
                    allow-tracing="{{isTracing(mainPhotoItem.sectionId, view, photo, mainPhotoItem, 'main')}}"
                    use-metric-units="[[userData.use_metric_units]]"
                    use-decimal-feet="[[userData.use_decimal_feet]]"
                    load-data
                    disabled="[[!signedIn]]"
                    photo-association="{{getMainPhotoAssociation(view)}}"
                    zoom
                    scroll-sensitivity="[[scrollSensitivity]]"
                    annotations="{{showAnnotations('trace', showLines, 'main')}}"
                    show-sag="{{showSag}}"
                    show-clearances="{{showClearances}}"
                    config="{{modelConfig}}"
                    name$="{{photo}}"
                    photo-id="{{photo}}"
                    use-lazy-loading
                    job-id="{{jobId}}"
                    job-styles="[[jobStyles]]"
                    input-models="{{inputModels}}"
                    input-model-group="{{of(inputModelGroups, inputModelGroup)}}"
                    other-attributes="[[otherAttributes]]"
                    user-group="{{userGroup}}"
                    on-reload-urls="reloadJobUrls"
                    tabindex="0"
                    auto-resize
                    trace-listeners="{{traceListeners}}"
                    single-click-list="{{singleClickList}}"
                    mode="{{mode}}"
                    uid="{{user.uid}}"
                    on-open-chooser="openChooser"
                    job-creator="[[jobCreator]]"
                    on-photo-library-trigger="togglePhotoChooser"
                    on-zoomed="calcChooserScale"
                    on-toast="displayToastMessage"
                    on-marker-selected="markerSelected"
                    on-marker-deselected="markerDeselected"
                    photo-data-loaded="{{mainPhotoDataLoaded}}"
                    on-photo-data-loaded="photoDataLoaded"
                    users="[[users]]"
                    user-modules="[[userModules]]"
                    make-ready-clearances="[[getItemById('makeReadyClearances')]]"
                    has-make-ready-rules="[[!equal(makeReadyClearances.length, 0)]]"
                    left-photo-id="{{photoLeft}}"
                    right-photo-id="{{photoRight}}"
                    distance-ratios="{{mainPhotoItem.distanceRatios}}"
                    default-power-company="[[defaultPowerCompany]]"
                    default-company="[[defaultCompany]]"
                    job-creator="[[jobCreator]]"
                    toolbar
                    toolbar-is-hidden="{{toolbarIsHidden}}"
                    toolbar-height="{{toolbarHeight}}"
                    on-enable-make-ready="enableMakeReady"
                    on-open-photo="openPhoto"
                    published="[[locked]]"
                    on-exit-view="exitView"
                    input-model-group-keys="[[inputModelGroupKeys]]"
                    input-model-group-key="{{inputModelGroup}}"
                    model-defaults="[[modelDefaults]]"
                    on-confirm="confirmEvent"
                    show-warnings
                    sag-data="[[sagData]]"
                    proposed-sag-data="[[proposedSagData]]"
                  >
                    <katapult-button icon="map" on-click="openInMaps" class="findInMapsButton" slot="toolbar-info-content"
                      >Find in Maps</katapult-button
                    >
                    <template is="dom-if" if="[[!equal(view, 'trace)]]">
                      <template is="dom-if" if="[[placeTaken]]">
                        <katapult-button icon="explore" on-click="zoomToPlaceTaken" class="findInMapsButton" slot="toolbar-info-content"
                          >Zoom to Place Taken</katapult-button
                        >
                      </template>
                    </template>
                    <template is="dom-if" if="{{equal(view, 'trace')}}">
                      <katapult-photo-label
                        user-group="[[userGroup]]"
                        uid="[[user.uid]]"
                        company="[[jobCreator]]"
                        nodes="[[array(leftNode, rightNode)]]"
                        show-clearances="{{showClearances}}"
                        slot="toolbar-label"
                        user-modules="[[userModules]]"
                      ></katapult-photo-label>
                      <!-- <div class="photoLabel" slot="toolbar-label">
                          <template is="dom-repeat" items="{{joinArrays(leftLabels, rightLabels, ' - ')}}">
                            <span>{{item}}</span>
                            <br />
                          </template>
                        </div> -->
                    </template>
                  </katapult-photo-viewer>
                  <template is="dom-if" if="{{showUpshotMeasurementButtons}}">
                    <div class="mainPhotoContextMenuTrayContainer" on-keydown="stopPropagation">
                      <div class="mainPhotoContextMenuTray">
                        <span>
                          <span><em>Estimated</em> Total Length: </span><span>{{totalUpshotMeasurement}}</span><span> '</span>
                        </span>
                        <katapult-button class="mainPhotoContextMenuPaperButtonConfirm" on-click="upshotViewDone">Done</katapult-button>
                      </div>
                    </div>
                  </template>
                </resizeable-div>
                <template is="dom-if" if="{{showBlankPhotoButton(mainPhotoItem.sectionId, view, photo, mainPhotoItem)}}">
                  <div class="insertBlankButtonContainer">
                    <span class="blankItemLabel">Section Without a Photo.</span>
                    <katapult-button
                      class="insertBlankButton"
                      on-click="insertBlankPhoto"
                      data-type="section"
                      data-item-id$="{{mainPhotoItem.sectionId}}"
                      >Insert Blank Photo for Measuring?</katapult-button
                    >
                  </div>
                </template>
                <!--Other Section Photos-->
                <template is="dom-if" if="{{!isView(view, 'upshot', 'cuEntry', 'transferHeights', 'pci')}}">
                  <template is="dom-repeat" items="{{traceSections}}" as="section" index-as="sectionIndex">
                    <resizeable-div
                      class="sidePhotoContainer"
                      left
                      right
                      hidden$="{{!section.mainPhoto}}"
                      disabled="[[disableManualPhotoResize]]"
                    >
                      <template is="dom-if" if="{{equal(view, 'trace')}}">
                        <katapult-photo-chooser
                          job-id="[[jobId]]"
                          name="section"
                          uid="{{user.uid}}"
                          user-group="{{userGroup}}"
                          item="{{section}}"
                          tier="[[tier]]"
                          use-metric-units="[[userData.use_metric_units]]"
                          use-decimal-feet="[[userData.use_decimal_feet]]"
                          class="fitParent"
                          selected="{{section.mainPhoto}}"
                          on-chooser-select="chooserSelect"
                          on-chooser-photo-tap="openPhoto"
                          model-config="{{modelConfig}}"
                        ></katapult-photo-chooser>
                      </template>
                      <katapult-photo-viewer
                        item="{{section}}"
                        left-node="{{leftNode}}"
                        right-node="{{rightNode}}"
                        metadata="[[metadata]]"
                        enabled-features="[[enabledFeatures]]"
                        annotation-editor-show-menu="{{annotationEditorShowMenu}}"
                        in-extraction-loop="{{inExtractionLoop}}"
                        visible-buttons="{{getVisibleButtons(section, 'false', 'section', modelConfig.*, tier, view, locked, showClearances, userGroup, enabledFeatures.*)}}"
                        class$="{{getDrawingClass(mode, view)}} fitParent tracingPhoto"
                        allow-tracing="{{isTracing(section.sectionId, view, section.mainPhoto, section)}}"
                        use-metric-units="[[userData.use_metric_units]]"
                        use-decimal-feet="[[userData.use_decimal_feet]]"
                        load-data=""
                        disabled="[[!signedIn]]"
                        photo-association="connection"
                        zoom=""
                        scroll-sensitivity="[[scrollSensitivity]]"
                        annotations="{{showAnnotations(view, showLines, 'section')}}"
                        show-sag="{{showSag}}"
                        show-clearances="{{showClearances}}"
                        config="{{modelConfig}}"
                        name$="{{section.mainPhoto}}"
                        photo-id="{{section.mainPhoto}}"
                        job-id="{{jobId}}"
                        job-styles="[[jobStyles]]"
                        input-models="{{inputModels}}"
                        input-model-group="{{of(inputModelGroups, inputModelGroup)}}"
                        other-attributes="[[otherAttributes]]"
                        user-group="{{userGroup}}"
                        on-reload-urls="reloadJobUrls"
                        tabindex="0"
                        auto-resize=""
                        trace-listeners="{{traceListeners}}"
                        single-click-list="{{singleClickList}}"
                        mode="{{mode}}"
                        uid="{{user.uid}}"
                        on-photo-data-loaded="photoDataLoaded"
                        on-open-chooser="openChooser"
                        job-creator="[[jobCreator]]"
                        on-photo-library-trigger="togglePhotoChooser"
                        users="[[users]]"
                        make-ready-clearances="[[getItemById('makeReadyClearances')]]"
                        has-make-ready-rules="[[!equal(makeReadyClearances.length, 0)]]"
                        job-creator="[[jobCreator]]"
                        left-photo-id="{{photoLeft}}"
                        right-photo-id="{{photoRight}}"
                        distance-ratios="{{section.distanceRatios}}"
                        default-power-company="[[defaultPowerCompany]]"
                        default-company="[[defaultCompany]]"
                        toolbar=""
                        toolbar-is-hidden="{{toolbarIsHidden}}"
                        toolbar-height="{{toolbarHeight}}"
                        user-modules="[[userModules]]"
                        on-enable-make-ready="enableMakeReady"
                        on-open-photo="openPhoto"
                        published="[[locked]]"
                        input-model-group-keys="[[inputModelGroupKeys]]"
                        input-model-group-key="{{inputModelGroup}}"
                        model-defaults="[[modelDefaults]]"
                        on-confirm="confirmEvent"
                        show-warnings
                        on-marker-selected="updateThreeDViewSelectedTraceData"
                        sag-data="[[sagData]]"
                        proposed-sag-data="[[proposedSagData]]"
                      >
                        <katapult-button icon="map" on-click="openInMaps" class="findInMapsButton" slot="toolbar-info-content"
                          >Find in Maps</katapult-button
                        >
                        <template is="dom-if" if="{{equal(view, 'trace')}}">
                          <katapult-photo-label
                            user-group="[[userGroup]]"
                            uid="[[user.uid]]"
                            company="[[jobCreator]]"
                            nodes="[[array(leftNode, rightNode)]]"
                            show-clearances="{{showClearances}}"
                            slot="toolbar-label"
                            user-modules="[[userModules]]"
                          ></katapult-photo-label>
                          <!-- <div class="photoLabel" slot="toolbar-label">
                              <template is="dom-repeat" items="{{joinArrays(leftLabels, rightLabels, ' - ')}}">
                                <span>{{item}}</span>
                                <br />
                              </template>
                            </div> -->
                        </template>
                      </katapult-photo-viewer>
                    </resizeable-div>
                    <template is="dom-if" if="{{showBlankPhotoButton(section.sectionId, view, section.mainPhoto, section)}}">
                      <div class="insertBlankButtonContainer">
                        <span class="blankItemLabel">Section Without a Photo.</span>
                        <katapult-button
                          class="insertBlankButton"
                          on-click="insertBlankPhoto"
                          data-type="section"
                          data-item-id$="{{section.sectionId}}"
                          >Insert Blank Photo for Measuring?</katapult-button
                        >
                      </div>
                    </template>
                  </template>
                </template>
                <!--Photo Right-->
                <resizeable-div
                  class="sidePhotoContainer right"
                  left
                  right
                  hidden$="[[!calcShowViewer('right', photoRight, view)]]"
                  disabled="[[disableManualPhotoResize]]"
                >
                  <template is="dom-if" if="{{equal(view, 'trace')}}">
                    <katapult-photo-chooser
                      job-id="[[jobId]]"
                      name="node"
                      uid="{{user.uid}}"
                      user-group="{{userGroup}}"
                      item="{{rightNode}}"
                      tier="[[tier]]"
                      use-metric-units="[[userData.use_metric_units]]"
                      use-decimal-feet="[[userData.use_decimal_feet]]"
                      class="fitParent"
                      selected="{{photoRight}}"
                      on-chooser-select="chooserSelect"
                      on-chooser-photo-tap="openPhoto"
                      on-open-transfer-heights="openTransferHeights"
                      model-config="{{modelConfig}}"
                    ></katapult-photo-chooser>
                  </template>
                  <katapult-photo-viewer
                    id="photoRight"
                    annotation-editor-show-menu="{{annotationEditorShowMenu}}"
                    in-extraction-loop="{{inExtractionLoop}}"
                    item="{{rightNode}}"
                    visible-buttons="{{getVisibleButtons(rightNode, 'true', 'photoRight', modelConfig.*, tier, view, locked, showClearances, userGroup, alternateDesignsConfig, enabledFeatures.*)}}"
                    class$="{{getDrawingClass(mode, view)}} fitParent tracingPhoto"
                    allow-tracing="{{isTracing(rightNode.nodeId, view, photoRight)}}"
                    load-data
                    disabled="[[!signedIn]]"
                    use-metric-units="[[userData.use_metric_units]]"
                    use-decimal-feet="[[userData.use_decimal_feet]]"
                    photo-association="[[getPhotoAssociation(rightNode)]]"
                    zoom="{{isView(view, 'trace', 'transferHeights', 'pci')}}"
                    scroll-sensitivity="[[scrollSensitivity]]"
                    annotations="{{showAnnotations(view, showLines, 'right')}}"
                    on-exit-view="exitView"
                    on-open-upshot-view="openUpshotView"
                    show-clearances="{{showClearances}}"
                    config="{{modelConfig}}"
                    name$="{{photoRight}}"
                    photo-id="{{photoRight}}"
                    use-lazy-loading
                    photo-data="{{photoRightData}}"
                    job-id="{{jobId}}"
                    job-styles="[[jobStyles]]"
                    input-models="{{inputModels}}"
                    input-model-group="{{of(inputModelGroups, inputModelGroup)}}"
                    other-attributes="[[otherAttributes]]"
                    user-group="{{userGroup}}"
                    on-click="setPictureLeftRight"
                    on-reload-urls="reloadJobUrls"
                    tabindex="0"
                    auto-resize
                    trace-listeners="{{traceListeners}}"
                    single-click-list="{{singleClickList}}"
                    mode="{{mode}}"
                    uid="{{user.uid}}"
                    on-open-chooser="openChooser"
                    job-creator="[[jobCreator]]"
                    on-photo-library-trigger="togglePhotoChooser"
                    on-zoomed="calcChooserScale"
                    users="[[users]]"
                    user-modules="[[userModules]]"
                    make-ready-clearances="[[getItemById('makeReadyClearances')]]"
                    has-make-ready-rules="[[!equal(makeReadyClearances.length, 0)]]"
                    distance-ratios="[[ifPci(pciDistanceRatios)]]"
                    default-power-company="[[defaultPowerCompany]]"
                    default-company="[[defaultCompany]]"
                    disclaimer-exists="{{rightDisclaimer}}"
                    no-fit="[[equal(view, 'photos')]]"
                    toolbar="[[isView(view, 'trace', 'pci')]]"
                    toolbar-is-hidden="{{toolbarIsHidden}}"
                    toolbar-height="{{toolbarHeight}}"
                    on-enable-make-ready="enableMakeReady"
                    on-open-photo="openPhoto"
                    job-creator="[[jobCreator]]"
                    left-photo-id="[[ifPci(leftNodePhotoId)]]"
                    right-photo-id="[[ifPci(rightNodePhotoId)]]"
                    published="[[locked]]"
                    input-model-group-keys="[[inputModelGroupKeys]]"
                    input-model-group-key="{{inputModelGroup}}"
                    on-confirm="confirmEvent"
                    on-cleared-markers="clearedMarkers"
                    alternate-designs-config="[[alternateDesignsConfig]]"
                    model-defaults="[[modelDefaults]]"
                    show-warnings
                    on-marker-selected="updateThreeDViewSelectedTraceData"
                  >
                    <katapult-button icon="map" on-click="openInMaps" class="findInMapsButton" slot="toolbar-info-content"
                      >Find in Maps</katapult-button
                    >
                    <template is="dom-if" if="{{equal(view, 'trace')}}">
                      <katapult-photo-label
                        user-group="[[userGroup]]"
                        uid="[[user.uid]]"
                        company="[[jobCreator]]"
                        nodes="[[array(rightNode)]]"
                        show-clearances="{{showClearances}}"
                        slot="toolbar-label"
                        user-modules="[[userModules]]"
                      ></katapult-photo-label>
                      <!-- <div class="photoLabel" slot="toolbar-label">
                          <template is="dom-repeat" items="{{rightLabels}}">
                            <span>{{item}}</span>
                            <br />
                          </template>
                          <template is="dom-if" if="{{rightDisclaimer}}">
                            <div class="disclaimerSpacer"></div>
                          </template>
                        </div> -->
                    </template>
                    <template is="dom-if" if="{{equal(view, 'photos')}}">
                      <paper-ripple noink></paper-ripple>
                      <iron-icon class="leftRightIcon" icon="chevron-right"></iron-icon>
                    </template>
                  </katapult-photo-viewer>
                </resizeable-div>
                <template is="dom-if" if="{{!isView(view, 'upshot', 'cuEntry')}}">
                  <template is="dom-if" if="{{showBlankPhotoButton(rightNode.nodeId, view, photoRight)}}">
                    <div class="insertBlankButtonContainer">
                      <span class="blankItemLabel">Node Without a Photo.</span>
                      <katapult-button
                        class="insertBlankButton"
                        on-click="insertBlankPhoto"
                        data-type="node"
                        data-item-id$="{{rightNode.nodeId}}"
                        >Insert Blank Photo for Measuring?</katapult-button
                      >
                    </div>
                  </template>
                </template>
              </photo-controls>
              <!--Upshot Photos-->
              <upshot-measurement
                id="upshotMeasurement"
                view="{{view}}"
                job-id="{{jobId}}"
                disabled="[[!signedIn]]"
                use-metric-units="[[userData.use_metric_units]]"
                use-decimal-feet="[[userData.use_decimal_feet]]"
                total-upshot-measurement="{{totalUpshotMeasurement}}"
                show-upshot-measurement-buttons="{{showUpshotMeasurementButtons}}"
              ></upshot-measurement>
              <!--PCI Routine-->
              <pci-routine
                id="pci"
                disabled="[[!equal(view, 'pci')]]"
                style$="[[getPCIStyle(view, photoRight)]]"
                job-id="[[jobId]]"
                uid="[[user.uid]]"
                metadata="[[metadata]]"
                validation-routine="[[validationRoutine]]"
                pre-construction-photo="{{photoLeft}}"
                pre-construction-photo-data="[[photoLeftData]]"
                pci-distance-ratios="{{pciDistanceRatios}}"
                left-node-photo-id="{{leftNodePhotoId}}"
                right-node-photo-id="{{rightNodePhotoId}}"
                post-construction-photo="{{photoRight}}"
                post-construction-photo-data="[[photoRightData]]"
                active-pci-item-data="{{activePciItemData}}"
                other-attributes="[[otherAttributes]]"
                user-group="[[userGroup]]"
                job-creator="[[jobCreator]]"
                locked="[[locked]]"
                job-styles="[[jobStyles]]"
              >
              </pci-routine>
              <!--CU Entry-->
              <cu-entry
                id="cuEntry"
                company-id="{{jobCreator}}"
                job-name="{{jobName}}"
                job-id="{{jobId}}"
                view="[[view]]"
                other-attributes="[[otherAttributes]]"
                use-metric-units="[[useMetricUnits]]"
                trace-listeners="[[traceListeners]]"
                alternate-designs-config="[[alternateDesignsConfig]]"
                model-defaults="[[modelDefaults]]"
                user-group="[[userGroup]]"
                uid="[[user.uid]]"
                job-name="[[jobName]]"
                on-confirm="confirmEvent"
                on-toast="displayToastMessage"
              ></cu-entry>
              <template is="dom-if" if="[[showTransferHeights(view, heightsTransfered)]]">
                <div id="transferHeightsPrompt">
                  <katapult-button color="var(--secondary-color)" on-click="transferHeightMarkers"
                    >Done with Anchors, Transfer Heights</katapult-button
                  >
                </div>
              </template>
            </div>
            <iron-collapse id="multipleAssociatedNodes" opened="{{_computeOpened(associatedLocationList)}}">
              <div style="padding:10px;">
                <p>This Photo is Associated To Multiple Locations:</p>
                <template is="dom-repeat" items="{{associatedLocationList}}" as="location">
                  <katapult-button icon="map" on-click="selectZoomLocation" on-dblclick="selectZoomLocation" raised=""
                    ><span>{{location.type}}</span> <span>{{location.key}}</span></katapult-button
                  >
                </template>
              </div>
            </iron-collapse>
            <!--List of photos for navigation-->
            <template is="dom-if" if="{{equal(view, 'photos')}}">
              <template is="dom-repeat" items="{{avatars}}" as="avatar">
                <template is="dom-if" if="[[!equal(avatar.$key, user.uid)]]">
                  <avatar-icon
                    email="{{avatar.email}}"
                    last-seen="{{avatar.lastLog}}"
                    triangle
                    targeted-positioning
                    position-target="[[getPhotoListItem(avatar.photo_id, updateAvatarParent)]]"
                    update-position="[[updateAvatarPosition]]"
                  ></avatar-icon>
                </template>
              </template>
              <div id="photoList" class$="{{photoListClasses}}" on-scroll="photoListScroll">
                <div id="photoListPhotos">
                  <template is="dom-repeat" items="{{filteredPhotoKeys}}">
                    <div
                      id$="listItem[[item]]"
                      on-click="setPicture"
                      style$="[[getProgressItemStyle(item, photo, showPossibleSyncPhotos, mainPhotoItem.photos, selectedPhotos.*, photosToHighlight.*, photoSummary.*)]]"
                      class="progressItem"
                      draggable="true"
                      on-dragstart="photoListDragStart"
                      on-dragend="deslecteAllPhotos"
                    ></div>
                  </template>
                </div>
              </div>
            </template>
            <template is="dom-if" if="{{!equal(selectedPhotos.length, 0)}}">
              <div
                id="selectedPhotoCounter"
                class$="{{photoListClasses}}"
                draggable="true"
                on-dragstart="photoListDragStart"
                on-dragend="deslecteAllPhotos"
              >
                <katapult-button
                  id="deselectPhotosButton"
                  icon="close"
                  iconOnly
                  color="var(--secondary-color)"
                  on-click="deslecteAllPhotos"
                ></katapult-button>
                <paper-tooltip for="deselectPhotosButton" position="left">Deselect Photos</paper-tooltip>
                <span>{{getSelectedPhotoLabel(selectedPhotos.length)}} selected</span>
                <paper-menu-button id="morePhotoOptions" no-overlap horizontal-offset="-225" vertical-align="bottom">
                  <katapult-button icon="more_vert" iconOnly color="var(--secondary-color)" slot="dropdown-trigger"></katapult-button>
                  <paper-item slot="dropdown-content" on-click="unassociatePhotos"
                    ><iron-icon icon="cancel"></iron-icon>Unassociate Photos</paper-item
                  >
                  <paper-item slot="dropdown-content" on-click="associatePhotos"
                    ><iron-icon icon="image:photo-library"></iron-icon>Associate Photos</paper-item
                  >
                  <paper-item slot="dropdown-content" on-click="deletePhotos"
                    ><iron-icon icon="delete"></iron-icon>Delete Photos</paper-item
                  >
                  <paper-item slot="dropdown-content" data-key="name" on-click="sortPhotos"
                    ><iron-icon icon="av:sort-by-alpha"></iron-icon>Sort Photos By Name</paper-item
                  >
                  <paper-item slot="dropdown-content" data-key="sync" on-click="sortPhotos"
                    ><iron-icon icon="social:public"></iron-icon>Sort Photos By Sync Time</paper-item
                  >
                  <paper-item slot="dropdown-content" data-key="date" on-click="sortPhotos"
                    ><iron-icon icon="image:timer"></iron-icon>Sort Photos By Date Taken</paper-item
                  >
                  <paper-item slot="dropdown-content" data-key="classification" on-click="sortPhotos"
                    ><iron-icon icon="icons:font-download"></iron-icon>Sort Photos By Classification</paper-item
                  >
                </paper-menu-button>
              </div>
            </template>
          </div>
        </div>
        <photo-library
          id="photoLibrary"
          file-folder="{{config.firebaseData.amazonFolder}}"
          mode="{{mode}}"
          user-group="{{userGroup}}"
          uid="{{user.uid}}"
          job-id="{{jobId}}"
          other-attributes="{{otherAttributes}}"
          on-toast="displayToastMessage"
        ></photo-library>
        <div id="dragImageContainer">
          <div id="dragImage" class="dragImage"></div>
        </div>
      </katapult-auth>
    `;
  }

  static get properties() {
    return {
      annotationEditorShowMenu: {
        type: Boolean,
        value: false
      },
      collectionSets: {
        type: Array,
        value: () => []
      },
      selectedPhotos: {
        type: Array,
        value: () => {
          return [];
        }
      },
      mainPhotoItem: {
        type: Object,
        value: null
      },
      locked: {
        type: Boolean,
        value: false
      },
      leftNode: {
        type: Object,
        value: null
      },
      rightNode: {
        type: Object,
        value: null
      },
      hashKeys: {
        type: Array,
        value: function () {
          return [
            { property: 'jobId', requirement: /^[\w\-]{20}$/ },
            {
              property: 'photo',
              requirement: /^[\w\-]{20}$/,
              alternateRequirement: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
            },
            { property: 'filteredCollectionSets', requirement: /\[("[^"]*")(,\s*("[^"]*"))*\]/, stringify: true },
            { property: 'inputModelGroup' },
            { property: 'traceConnectionId', requirement: /^[\w\-]{20}$/ },
            { property: 'view', requirement: /^(photos|trace|upshot|cuEntry|transferHeights|pci)$/, fallback: 'photos' },
            { property: 'showLines', requirement: /^(true|false)$/ },
            { property: 'node1Id', requirement: /^[\w\-]{20}$/ },
            { property: 'validationRoutine', requirement: /^(true|false)$/ }
            // 'activeData',
            // 'linked'
          ];
        }
      },
      _editors: {
        type: Object
      },
      activeData: {
        type: Object,
        value: function () {
          return {
            key: null,
            itemKey: null,
            photoId: null
          };
        },
        observer: 'updateHash'
      },
      activeTrace: {
        type: String,
        value: null
      },
      activePciItemData: {
        type: Object,
        observer: 'activePciItemDataChanged'
      },
      allowThreeAlignPoints: {
        type: String,
        value: false
      },
      attributeToAdd: {
        type: String,
        value: ''
      },
      cachedPhotos: {
        type: Object,
        value: function () {
          return {};
        }
      },
      calibratingCamera: {
        type: Boolean,
        value: false
      },
      calibrationResults: {
        type: Object,
        value: function () {
          return {};
        }
      },
      filteredCollectionSets: {
        type: Array,
        value: () => []
      },
      testCameraModel: {
        type: Object,
        value: function () {
          return {};
        }
      },
      focalLengthsToTest: {
        type: Array,
        value: function () {
          return [];
        }
      },
      aD_string: {
        type: String,
        value: null
      },
      bD_string: {
        type: String,
        value: null
      },
      cD_string: {
        type: String,
        value: null
      },
      lowest_score: {
        type: Number,
        value: null
      },
      lowest_score_iteration: {
        type: Number,
        value: null
      },
      heightsToUse: {
        type: String,
        value: '35, 40, 50, 60'
      },
      aMax: {
        type: Number,
        value: 0
      },
      aMin: {
        type: Number,
        value: 0
      },
      aIncr: {
        type: Number,
        value: 0.001
      },
      bMax: {
        type: Number,
        value: 0
      },
      bMin: {
        type: Number,
        value: 0
      },
      bIncr: {
        type: Number,
        value: 0.01
      },
      cMax: {
        type: Number,
        value: 0
      },
      cMin: {
        type: Number,
        value: -0.1
      },
      cIncr: {
        type: Number,
        value: 0.01
      },
      connection: {
        observer: 'connectionLoaded'
      },
      node1: {
        observer: 'node1Loaded'
      },
      node2: {
        observer: 'node2Loaded'
      },
      filteredPhotoKeys: {
        type: Array,
        value: () => [],
        computed: 'calcFilteredPhotoKeys(photoSummary, collectionSets, filteredCollectionSets.splices)'
      },
      photoSummary: {
        type: Object
      },
      photoSummaryRequired: {
        type: Boolean,
        value: false
      },
      photosToHighlight: {
        type: Array,
        value: []
      },
      deleteTraceText: {
        type: String,
        value: ''
      },
      fileBucket: {
        type: String,
        value: 'https://s3.amazonaws.com/photoheight/'
      },
      showPossibleSyncPhotos: {
        type: Boolean,
        value: false
      },
      inARoutine: {
        type: Boolean,
        value: false
      },
      inputModelGroup: { observer: 'updateHash' },
      jobCreatorChanged: {
        type: Boolean,
        value: false
      },
      jobId: {
        type: String,
        value: '',
        observer: 'jobIdChanged'
      },
      jobName: {
        type: String,
        observer: 'jobNameChanged'
      },
      inputModelGroups: {
        type: Object,
        observer: 'inputModelGroupsLoaded'
      },
      inputModelGroupKeys: {
        type: Array,
        computed: 'SortedKeys(inputModelGroups)'
      },
      logoutButton: Object,
      // linked: { observer: 'updateHash' },
      markerAdjustments: {
        type: Object,
        value: function () {
          return {};
        }
      },
      mode: {
        type: String,
        value: null
      },
      newAttribute: {
        type: String,
        value: null
      },
      nullZeroValue: {
        type: String,
        value: () => {
          return null;
        }
      },
      otherAttributes: {
        type: Object
      },
      photo: {
        value: ''
      },
      picklistToAddTo: {
        type: String,
        value: null
      },
      picklistsToAddTo: {
        type: Array,
        value: function () {
          return [];
        }
      },
      routineDone: {
        type: Boolean,
        value: false
      },
      showClearances: {
        type: Boolean,
        value: false
      },
      showLines: {
        type: Boolean,
        value: true,
        observer: 'updateHash'
      },
      singleClickList: {
        type: Object,
        computed: 'getSingleClickList(inputModelGroups, inputModelGroup, inputModels, routines)'
      },
      traceModels: {
        type: Object
      },
      traceListeners: {
        type: Object,
        value: () => {
          return { traceData: {}, traceItems: {} };
        }
      },
      traceConnectionId: { observer: 'traceConnectionIdChanged' },
      userGroup: String,
      view: {
        type: String,
        observer: 'viewChanged'
      },
      noPhotos: {
        type: Boolean,
        value: false
      },
      nothingSelected: {
        type: Boolean,
        value: false
      },
      scrollSensitivity: {
        type: Number,
        value: 1.0
      },
      modelDefaults: {
        type: Object,
        computed: 'computeModelDefaults(configDefaults, otherAttributes)',
        value: () => ModelDefaults()
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      disableManualPhotoResize: {
        type: Boolean,
        value: false
      }
    };
  }

  static get observers() {
    return [
      'checkIfSelected(jobId, filteredPhotoKeys.length)',
      'parseUserData(userData.*)',
      'setVirtualPosition(photo, jobId)',
      'getOverflow(view, filteredPhotoKeys.length)',
      'gotJobCreator(jobCreator)',
      'photosLoaded(filteredPhotoKeys.length)',
      'updateHash(filteredCollectionSets.splices, node1Id, validationRoutine)',
      'photoChanged(photo, view, filteredPhotoKeys.length)',
      'updatePhotoSummaryRequired(view)',
      'useMetricUnitsChanged(userData.use_metric_units)',
      'useDecimalFeetChanged(userData.use_decimal_feet)',
      'rightClickOneClickMenuChanged(userData.right_click_one_click_menu)',
      'showOneClickMenuChanged(userData.show_one_click_menu)',
      'findPlaceTaken(mainPhotoDataLoaded)',
      'updateNode2Id(view, node1Id)',
      'calcStickAlignUsingSetValues(userGroup, photo, useSetValues, aSet, bSet, cSet)',
      'setDisableManualPhotoResize(enabledFeatures.manual_photo_resize, view)',
      'lockPhotoOnLoad(readOnlyUser, sharing, jobStatus.published, enabledFeatures.job_locking)',
      'updateJobLocking(metadata.job_locked)',
      'setScrollSensitivity(userData.scroll_sensitivity)'
    ];
  }

  static get importMeta() {
    return import.meta;
  }

  constructor() {
    super();
    this.config = config;
    this.SortedKeys = SortedKeys;
  }

  connectedCallback() {
    super.connectedCallback();

    this.jobLockingFlagListener = addFlagListener('job_locking', (enabled) => {
      this.set('enabledFeatures.job_locking', enabled);
    });
    this.manualPhotoResizeFlagListener = addFlagListener('manual_photo_resize', (enabled) => {
      this.set('enabledFeatures.manual_photo_resize', enabled);
    });
    this.sagCalculationViewFlagListener = addFlagListener('sag_calculation_view', (enabled) => {
      this.set('enabledFeatures.sag_calculation_view', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    removeFlagListener('job_locking', this.jobLockingFlagListener);
    removeFlagListener('manual_photo_resize', this.manualPhotoResizeFlagListener);
    removeFlagListener('sag_calculation_view', this.sagCalculationViewFlagListener);
  }

  ready() {
    super.ready();

    this.appConfiguration = new AppConfiguration(this);
    this.pageLoaded = true;
    this.listen(window, 'hashchange', 'hashChanged');
    this.hashChanged();
    this.loadedHash = true;
    if (this.view == 'cuEntry' || this.view == 'transferHeights') this.toggleView(null, 'trace');
    if (this.view == 'pci') this.openPciRoutine();
    this.checkIfSelected();
    this.$.mainPhoto.focus();
    this.boundGetCollectionSetName = this.getCollectionSetName.bind(this);
    this.boundGetCollectionSetActive = this.getCollectionSetActive.bind(this);
    this.boundUpdateFilteredCollectionSets = this.updateFilteredCollectionSets.bind(this);
  }
  array() {
    return Array.from(arguments);
  }
  and() {
    var val = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      val = val && arguments[i];
    }
    return val;
  }
  isOldApp() {
    return window.config.appName != 'ppl-kws';
  }
  ifPci(value) {
    return this.view == 'pci' ? value : null;
  }
  calcFilteredPhotoKeys(photoSummary) {
    let cameraKeys = [];
    this.filteredCollectionSets.forEach((collectionSetId) =>
      Object.keys(
        SquashNulls(
          this.collectionSets.find((collectionSet) => collectionSet.$key == collectionSetId),
          'cameras'
        ) || {}
      ).forEach((cameraId) => cameraKeys.push(cameraId))
    );
    let temp = [];
    for (let photoId in photoSummary) {
      let photo = photoSummary[photoId];
      if (!cameraKeys.length || cameraKeys.indexOf(photo.camera_id) !== -1) {
        temp.push(photoId);
      }
    }
    return temp;
  }
  getPCIStyle(view, photoRight) {
    return view == 'pci' && photoRight == null ? 'width: 150%;' : '';
  }
  calcShowViewer(viewer, photo, view) {
    if (viewer == 'left' || viewer == 'right') return photo != null && !this.isView(view, 'upshot', 'cuEntry');
    return photo != null;
  }
  computeModelDefaults(configDefaults, otherAttributes) {
    return ModelDefaults(configDefaults, otherAttributes);
  }
  updateNode2Id() {
    if (this.view == 'pci') this.node2Id = this.node1Id;
  }
  or() {
    var val = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      val = val || arguments[i];
    }
    return val;
  }
  slice(string, startIndex, endIndex) {
    if (typeof string === 'string') {
      return string.slice(startIndex, endIndex);
    }
  }
  isTracing(itemId, view, photoId, section, isMain) {
    if ((['trace', 'transferHeights', 'pci'].includes(view) || isMain) && !this.showBlankPhotoButton(itemId, view, photoId, section)) {
      return true;
    }
    return false;
  }
  showBlankPhotoButton(itemId, view, photoId, section) {
    if (itemId != null && photoId == null && view == 'trace' && section !== null) {
      return true;
    }
    return false;
  }
  isView(view) {
    for (var i = 1; i < arguments.length; i++) {
      if (arguments[i] == this.view) return true;
    }
    return false;
  }
  objectKeys(obj) {
    if (obj == null) {
      return obj;
    } else {
      var keys = Object.keys(obj);
      keys.sort(function (a, b) {
        return obj[a].priority - obj[b].priority;
      });
      return keys;
    }
  }
  appNameContains(appName, searchString) {
    return (appName || '').toLowerCase().indexOf(searchString.toLowerCase()) != -1;
  }
  getVisibleButtons(item, side, viewerId) {
    // Other Trigger Parameters: modelConfig.*, tier, view, locked, showClearances, alternateDesignsConfig
    if (side == 'true' && this.view == 'photos') return {};
    //photos|trace|upshot|cuEntry|transferHeights
    return {
      exit: ['cuEntry', 'transferHeights', 'pci'].includes(this.view),
      info: this.view === 'photos',
      zoom: this.view === 'photos',
      chooser: this.view == 'trace' && SquashNulls(item, 'photos') != null && !this.locked,
      hardware:
        this.view == 'trace' &&
        side == 'true' &&
        !this.locked &&
        !this.showClearances &&
        SquashNulls(this.modelConfig, 'hardware_details_button'),
      upshot:
        this.view == 'trace' && side == 'true' && SquashNulls(this.modelConfig, 'upshot_view') && !this.locked && !this.showClearances,
      filters: true,
      minimize:
        ['cuEntry', 'transferHeights', 'pci'].includes(this.view) ||
        (this.view != 'photos' && side == 'true' && SquashNulls(this.modelConfig, 'minimize_button')),
      rotate: true,
      renderedPoleMode: this.view == 'trace' && side == 'true',
      historicalPhotoChooser: true,
      resetMr: this.showClearances && !this.locked && this.view == 'trace' && side == 'false',
      alternateDesigns:
        Object.keys(this.alternateDesignsConfig || {}).length &&
        this.showClearances &&
        !this.locked &&
        (this.view == 'trace' || (this.view == 'pci' && this.validationRoutine && viewerId == 'photoRight')) &&
        side == 'true',
      worstCaseSag: this.showClearances && !this.locked && this.view == 'trace' && side == 'false' && this.userGroup == 'katapult',
      poleReplacement: this.showClearances && !this.locked && side == 'true' && this.view == 'trace',
      cuEntry: this.showClearances && !this.locked && side == 'true' && this.view == 'trace',
      clearAllMarkers: ['transferHeights'].includes(this.view) && viewerId == 'photoRight',
      availableSpace: this.showClearances && this.view == 'trace' && SquashNulls(this.modelConfig, 'show_available_space') != ''
    };
  }
  hashChanged() {
    let hashList = decodeURI(window.location.hash.substring(1)).split('/');
    for (let i = 0; i < this.hashKeys.length; i++) {
      if (i < hashList.length) {
        if (
          this.hashKeys[i].requirement == null ||
          hashList[i].search(this.hashKeys[i].requirement) == 0 ||
          (this.hashKeys[i].alternateRequirement && hashList[i].search(this.hashKeys[i].alternateRequirement) == 0)
        ) {
          let newVal = hashList[i].replace(/_\[\]_/g, '/');
          try {
            newVal = JSON.parse(newVal);
          } catch (e) {}
          this[this.hashKeys[i].property] = newVal;
        } else if (this.hashKeys[i].fallback) {
          this[this.hashKeys[i].property] = this.hashKeys[i].fallback;
        }
      }
    }
    this.updateHash();
  }
  updateHash() {
    if (this.loadedHash) {
      var hash = '';
      for (var i = 0; i < this.hashKeys.length; i++) {
        if (i > 0) {
          hash += '/';
        }
        let val = this[this.hashKeys[i].property];
        if (this.hashKeys[i].stringify) val = JSON.stringify(val);
        hash += this.encodeHashComponent(val);
      }
      window.location.hash = hash;
    }
  }
  updatePhotoSummaryRequired() {
    this.photoSummaryRequired = this.view === 'photos';
  }
  encodeHashComponent(text) {
    var property = (text || '') + '';
    return property.replace(/\//g, '_[]_');
  }
  findPlaceTaken() {
    this.findPlaceTakenDebouncer = Debouncer.debounce(this.findPlaceTakenDebouncer, timeOut.after(1000), () => {
      // Get photo's synced time.
      let time = this.get('$.mainPhoto.photoData.synced_time');
      // Query logs within 10 seconds of this time.
      if (time)
        FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/gps_logs`)
          .orderByChild('time')
          .startAt(time - 10000)
          .endAt(time + 10000)
          .once('value')
          .then((s) => {
            // Find nearest log and use it's location as placeTaken.
            let logs = Object.values(s.val() || {}).sort((a, b) => Math.abs(time - a.time) - Math.abs(time - b.time));
            if (logs.length > 1) {
              let deltaA = Math.abs(time - logs[0].time);
              let deltaB = Math.abs(time - logs[1].time);
              let timeBetweenLogs = deltaA + deltaB;
              // Note, we are using deltaB with A and deltaA with B because we don't want to favor the larger delta, but the smaller.
              let interpolatedLat = (logs[0].l[0] * deltaB) / timeBetweenLogs + (logs[1].l[0] * deltaA) / timeBetweenLogs;
              let interpolatedLng = (logs[0].l[1] * deltaB) / timeBetweenLogs + (logs[1].l[1] * deltaA) / timeBetweenLogs;
              this.placeTaken = [interpolatedLat, interpolatedLng];
            } else if (logs.length) {
              this.placeTaken = logs[0].l;
            } else this.placeTaken = null;
          });
    });
  }
  zoomToPlaceTaken() {
    if (this.placeTaken) {
      this.zoomMapToLocation({
        type: 'point',
        latitude: this.placeTaken[0],
        longitude: this.placeTaken[1],
        zoomText: `Coords where ${this.get('$.mainPhoto.photoData.filename')} was taken`
      });
    }
  }
  onSignOut(e) {
    if (e.detail.manual) {
      this.jobId = '';
    }
  }
  upshotViewDone() {
    if (this.powerHardwareUpshotMeasurement) {
      this.set('userData.photoTookLinkingAction', true);
    } else {
      this.toggleView(null, 'trace');
    }
  }
  gotJobCreator() {
    this.jobCreatorChanged = !this.jobCreatorChanged;
  }
  getMainPhotoStyle(view) {
    return `position: ${this.view === 'trace' || this.view === 'upshot' || this.view == 'cuEntry' ? 'relative' : 'absolute'};`;
  }
  getModelsUrl(userGroup, jobId, jobCreatorChanged, modelType) {
    if (!this.userGroup) return;

    let company = this.jobCreator;
    if (jobId == '') {
      company = userGroup;
    }
    return '/photoheight/company_space/' + company + '/models/' + modelType;
  }
  // TODO (03-23-2023): We define this function in two places. We should consolidate it.
  getSingleClickList(inputModelGroups, inputGroup, inputModels, routines) {
    // Wait until all the data is loaded
    if (!inputModelGroups || !inputGroup || !inputModels || !routines) return [];

    const list = [];
    const inputModelGroup = inputModelGroups?.[inputGroup];
    for (const [key, inputOpts] of Object.entries(inputModelGroup ?? {})) {
      const itemModel = routines?.[key] ?? inputModels?.[key];
      // Skip if the key starts with an underscore or if there is no item model
      if (key[0] == '_' || !itemModel) continue;

      const label = itemModel.name ?? CamelCase(FirebaseEncode.decode(itemModel.label ?? key));
      const shortcut = inputOpts._shortcut != null ? ` (${inputOpts._shortcut})` : '';
      list.push({
        value: key,
        label: `${label}${shortcut}`,
        description: itemModel.description,
        icons: itemModel.icons,
        _advance_photo: inputOpts._advance_photo
      });
    }

    // Sort the list by label
    const sortedList = list.sort((a, b) => a.label.localeCompare(b.label));
    return sortedList;
  }
  async showOneClickMenuChanged() {
    // If the value is null (meaning it probably loaded from Firebase
    // for the first time), then set to default value of true
    if (this.get('userData.show_one_click_menu') == null) {
      this.set('userData.show_one_click_menu', true);
    }
  }
  rightClickOneClickMenuChanged() {
    // If the value is null (meaning it probably loaded from Firebase
    // for the first time), then set to default value of false
    if (this.get('userData.right_click_one_click_menu') == null) {
      this.set('userData.right_click_one_click_menu', false);
    }
  }
  useMetricUnitsChanged() {
    if (this.get('userData.use_metric_units') == null) this.set('userData.use_metric_units', false);
  }
  useDecimalFeetChanged() {
    if (this.get('userData.use_decimal_feet') == null) this.set('userData.use_decimal_feet', false);
  }
  updateFilteredCollectionSets(e) {
    let index = (this.filteredCollectionSets || []).indexOf(e.target.collectionSetId);
    if (index !== -1) {
      this.splice('filteredCollectionSets', index, 1);
    } else {
      this.push('filteredCollectionSets', e.target.collectionSetId);
    }
  }
  getCollectionSetName(item) {
    let name = '';
    if (item) {
      if (item.name) {
        name = item.name;
      } else {
        if (item.date_collected) {
          name += new Date(item.date_collected).toLocaleDateString();
        }
        if (item.crew) {
          item.crew.forEach((uid) => {
            if (this.users && this.users[uid]) {
              if (name != '') name += ' ';
              name += this.users[uid].initials ? this.users[uid].initials : this.users[uid].email.split('@')[0];
            }
          });
        }
        if (item.last_upload) {
          if (name != '') name += ' ';
          name += '(Uploaded ' + new Date(item.last_upload).toLocaleDateString() + ')';
        }
      }
    }
    return name;
  }
  getCollectionSetActive(collectionSetId) {
    return (this.filteredCollectionSets || []).includes(collectionSetId);
  }
  insertBlankPhoto(e) {
    var type = e.currentTarget.getAttribute('data-type');
    var itemId = e.currentTarget.getAttribute('data-item-id');
    var url;
    if (type == 'node') {
      url = '/nodes/' + itemId + '/photos';
    } else if (type == 'section') {
      url = '/connections/' + this.traceConnectionId + '/sections/' + itemId + '/photos';
    }
    FirebaseWorker.ref('/photoheight/jobs/' + this.jobId + url).once(
      'value',
      function (snapshot) {
        var photos = snapshot.val();
        if (photos != null) {
          this.toggleView(null, 'trace');
        } else {
          var update = {};
          var photoId = FirebaseWorker.ref().push().key;
          var filename = 'Blank ' + type + ' photo';
          update['photos/' + photoId] = {
            associated_locations: {},
            skip_url_signing: true,
            image_width: 600,
            image_height: 800,
            tags: 'Blank Photos',
            filename: filename,
            uploaded_by: this.get('user.uid'),
            url_extra_large: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_' + type + '_photo.png',
            url_large: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_' + type + '_photo.png',
            url_small: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_' + type + '_photo.png',
            url_tiny: 'https://storage.googleapis.com/katapult-pro-shared-files/photos/blank_' + type + '_photo.png'
          };
          if (type == 'node') {
            update['photos/' + photoId].associated_locations[itemId] = 'node';
            update['nodes/' + itemId + '/photos/' + photoId] = { association: 'main' };
          } else if (type == 'section') {
            update['photos/' + photoId].associated_locations[this.traceConnectionId + ':' + itemId] = 'section';
            update['connections/' + this.traceConnectionId + '/sections/' + itemId + '/photos/' + photoId] = { association: 'main' };
          }
          update['photo_summary/' + photoId] = { name: filename, tags: 'Blank Photos', associated: true };
          FirebaseWorker.ref('/photoheight/jobs/' + this.jobId).update(
            update,
            function (error) {
              if (error) {
                this.$.toast.show(error.toString());
              } else {
                this.connectionLoaded();
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  }
  closeFullscreenPhoto() {
    this.$.fullscreenPhoto.close();
    this.fullscreenPhoto = null;
    this.fullscreenPhotos = null;
    this.fullscreenPhotoSrc = null;
  }
  setVirtualPosition() {
    if (this.get('user.uid') && this.photo && this.jobId != null) {
      let update = {};
      update['photoheight/company_space/' + this.userGroup + '/avatars/photos/' + this.get('user.uid')] = {
        photo_id: this.photo,
        job_id: this.jobId,
        lastLog: { '.sv': 'timestamp' },
        email: this.user.email
      };
      update['users/' + this.rootCompany + '/' + this.get('user.uid') + '/last_active'] = { '.sv': 'timestamp' };
      FirebaseWorker.ref().update(update, function (error) {
        if (error) {
          console.log('error', error);
        }
      });
    }
  }
  switchFullPhotoLeft() {
    this.switchFullPhoto(-1);
  }
  switchFullPhotoRight() {
    this.switchFullPhoto(1);
  }
  switchFullPhoto(offset) {
    var newIndex = this.fullscreenPhoto + offset;
    if (-1 < newIndex && newIndex < this.fullscreenPhotos.length) this.fullscreenPhoto = newIndex;
  }
  checkIfSelected() {
    if (this.pageLoaded) {
      if (!this.jobId && !this.filteredPhotoKeys.length) {
        this.noPhotos = false;
        this.nothingSelected = true;
        if (this.view == 'photos') {
          this.photoLeft = null;
          this.photoRight = null;
        }
      } else {
        this.nothingSelected = false;
      }
    }
  }
  showNoPhotosMessage(noPhotos, nothingSelected, showText) {
    var show = noPhotos && !nothingSelected;
    if (showText) {
      return show ? showText : '';
    }
    return show;
  }

  reloadJobUrls() {
    if (this.jobUrlsBusyLoading) return;
    this.$.toast.show({ text: 'Loading Fresh Photo Urls.', duration: Infinity });
    this.$.toast.duration = 6000;
    this.jobUrlsBusyLoading = true;
    var path = null;
    if (!this.filteredPhotoKeys.length) {
      path = 'photo_summary';
    }
    GetJobData(this.jobId, path).then((data) => {
      let request = {
        photos: {}
      };
      if (this.jobId != null && this.jobId != '') {
        request.jobId = this.jobId;
      }
      if (this.filteredPhotoKeys.length) {
        this.filteredPhotoKeys.forEach((photoId) => {
          let photoSummary = this.get(`photoSummary.${photoId}`) || {};
          if (
            !photoSummary.skip_url_signing &&
            photoSummary.name != 'Blank section photo' &&
            photoSummary.name != 'Blank node photo' &&
            photoId[0] == '-'
          ) {
            request.photos[photoId] = true;
          }
        });
      } else {
        for (var photoId in data.photo_summary) {
          if (
            !data.photo_summary[photoId].skip_url_signing &&
            data.photo_summary[photoId].name != 'Blank section photo' &&
            data.photo_summary[photoId].name != 'Blank node photo' &&
            photoId[0] == '-'
          ) {
            request.photos[photoId] = true;
          }
        }
      }
      firebase
        .functions()
        .httpsCallable('signS3JobPhotos')(request)
        .then((result) => {
          this.$.toast.close();
          this.$.toast.show(result.data);
          this.jobUrlsBusyLoading = false;
        })
        .catch((err) => {
          this.$.toast.close();
          this.$.toast.show(err.toString());
          this.jobUrlsBusyLoading = false;
        });
    });
  }
  displayInstalledToast() {
    this.$.toast.show('Caching complete! This app will work offline.');
  }
  getItemById(id) {
    var id = Array.prototype.slice.call(arguments).join('');
    return this.$[id] || this.shadowRoot.querySelector('#' + id);
  }
  getPhotoListItem(photoId) {
    return this.shadowRoot.querySelector('#listItem' + photoId);
  }
  photoListScroll() {
    this.updateAvatarPosition = !this.updateAvatarPosition;
  }
  getItem(object) {
    if (object == null || arguments.length <= 1) return null;
    var temp = object;
    for (var i = 1; i < arguments.length; i++) {
      if (temp == null) return null;
      if (typeof temp != 'object' && typeof temp != 'string') break;
      temp = temp[arguments[i]];
    }
    return temp;
  }
  chooserSelect(e) {
    if (this.view == 'upshot' && this.userGroup == 'katapult') {
      alert(
        '/photos is trying to set a main photo in upshot view. This is unexpected behavior.\n\nPlease let the coders know about this. It will likely cause photos to misassiciate to map objects.'
      );
    }
    var selectedPhoto = e.detail.selected;
    var featureType;
    var featureKey;
    var connId;
    if (e.detail.item.nodeId != null) {
      featureType = 'node';
      featureKey = e.detail.item.nodeId;
    } else if (e.detail.item.sectionId != null) {
      featureType = 'section';
      featureKey = e.detail.item.sectionId;
      connId = e.detail.item.connId;
    }
    var update = {};
    if (featureType && featureKey && selectedPhoto && e.detail.item.photos && e.detail.item.photos[selectedPhoto]) {
      var origin = null;
      if (featureType == 'node') {
        origin = '/nodes/';
      } else if (featureType == 'section') {
        origin = '/connections/' + connId + '/sections/';
      }
      if (origin) {
        let photos = e.detail.item.photos;
        for (var photoId in photos) {
          if (photos[photoId] == 'main' || photos[photoId].association == 'main') {
            update[`${origin + featureKey}/photos/${photoId}/association`] = true;
          }
        }
        update[`${origin + featureKey}/photos/${selectedPhoto}/association`] = 'main';
        FirebaseWorker.ref('/photoheight/jobs/' + this.jobId).update(update, function (err) {
          if (err) {
          }
        });
      }
    }
    // else {
    //   console.warn("Failed to write " + featureKey + " as 'main'");
    // }
  }
  async openPhoto(e) {
    if (e.detail.photoList) {
      this.fullscreenPhotos = e.detail.photoList;
      this.fullscreenPhoto = e.detail.photoIndex;
    } else if (e.detail.url) {
      this.fullscreenPhotoSrc = e.detail.url;
    }
    this.$.fullscreenPhoto.open();
    this.$.fullscreenPhoto.focus();
  }
  reOrientateImages() {
    if (this.reOrientateImage) {
      this.reOrientateImage = false;
      var photos = this.shadowRoot.querySelectorAll('katapult-photo');
      for (var i = 0; i < photos.length; i++) {
        photos[i].orientateImage();
      }
      this.imageLoaded();
    }
  }
  //todo fix 'detail'
  navigateToPhotoset(e) {
    for (var key in detail) {
      this.set(key, detail[key]);
    }
  }

  parseUserData() {
    // the initial load of userData.* calls this function a handful of times, debounce it so that we only get one result
    this.parseUserDataDebouncer = Debouncer.debounce(this.parseUserDataDebouncer, timeOut.after(50), () => {
      if (this.userData) {
        if (this.userData.hardware_details) {
          if (typeof this.userData.hardware_details.doing_anchor === 'string') {
            this.$.toast.show('Maps is out of date. Hard refresh Katapult Maps to get the latest code.');
          }
          if (this.userData.hardware_details.doing_anchor) {
            if (this.mode === 'hwDetail_DnGuy') {
              this.set('mode', null);
              this.$.photoControls.set('showDownGuyDetailToast', false);
            }
            this.$.photoControls.enterDownGuyDetail(this.userData.hardware_details.doing_anchor);
          } else if (this.userData.hardware_details.canceled === 'map' || this.userData.hardware_details.skipped === 'map') {
            FirebaseWorker.ref(
              '/photoheight/company_space/' + this.userGroup + '/user_data/' + this.get('user.uid') + '/hardware_details/canceled/'
            ).remove(function (error) {
              if (error) {
                console.log('error', error);
              }
            });
            if (this.mode === 'hwDetail_DnGuy') {
              this.set('mode', null);
              this.$.photoControls.set('showDownGuyDetailToast', false);
              if (this.traceConnectionId != null) {
                this.toggleView(null, 'trace');
              }
            }
          } else if (this.userData.hardware_details.done) {
            this.$.userData.ref.child('hardware_details/done').remove();
            if (this.traceConnectionId != null) {
              this.toggleView(null, 'trace');
            }
            this.$.toast.show('Done Entering Hardware Details.');
          }
        }
        if (this.userData.map_action && this.userData.map_action.transfer_manual_heights) {
          FirebaseWorker.ref(
            '/photoheight/company_space/' + this.userGroup + '/user_data/' + this.user.uid + '/map_action/transfer_manual_heights'
          ).remove();
          this.$.photoControls.enterNextManualHeightsDetail(this.userData.map_action.transfer_manual_heights);
        }
        if (this.userData.map_action && this.userData.map_action.jcop) {
          FirebaseWorker.ref('/photoheight/company_space/' + this.userGroup + '/user_data/' + this.user.uid + '/map_action/jcop').remove();
          this.$.photoControls.enterNextJcopDetail(this.userData.map_action.jcop);
        }
        if (this.userData.page_linking != null) {
          // jump to photo
          var page_linking = this.userData.page_linking;
          if (page_linking.locked != null) this.locked = page_linking.locked;
          if (page_linking.jobId != null) this.jobId = page_linking.jobId;
          if (page_linking.validationRoutine != null) this.validationRoutine = page_linking.validationRoutine;
          this.photosToHighlight = Array.isArray(page_linking.photosToHighlight) ? page_linking.photosToHighlight : [];
          var photoId = page_linking.photo;
          // this.set('userData.page_linking', null);
          this.$.userData.ref.child('page_linking').remove();
          if (photoId != null) {
            if (page_linking.action_type != 'cuEntry') {
              this.toggleView(null, 'photos');
              this.photo = photoId;
            }
            if (page_linking.property != null) {
              this.$.mainPhoto.clearSelectedAnnotation();
              if (page_linking.action_type === 'upshotLength') {
                // this.node1Id = page_linking.nodeId;
                this.set('nowLinking', page_linking);
                if (page_linking.marker_type != null) {
                  var attribute_name = null;
                  if (page_linking.marker_type === 'streetlight_top_of_bracket') {
                    attribute_name = 'streetlight_length';
                  } else if (page_linking.marker_type === 'street_light bottom_of_bracket') {
                    attribute_name = 'street_light_bracket_spec';
                  }
                  if (attribute_name != null) {
                    var ref = FirebaseWorker.ref(
                      '/photoheight/jobs/' +
                        this.jobId +
                        '/photos/' +
                        photoId +
                        '/photofirst_data/' +
                        page_linking.property +
                        '/' +
                        page_linking.itemKey +
                        '/' +
                        attribute_name
                    );
                    ref.once(
                      'value',
                      function (snapshot) {
                        var data = snapshot.val();
                        if (data == null) {
                          ref.set('');
                        }
                      }.bind(this)
                    );
                  }
                }
                this.powerHardwareUpshotMeasurement = true;
                this.setUpshotView(page_linking.nodeId, false, page_linking.property, page_linking.itemKey);
                window.setTimeout(() => {
                  this.$.mainPhoto.selectAnnotation(
                    page_linking.property,
                    page_linking.itemKey,
                    page_linking.property,
                    page_linking.itemKey,
                    null,
                    true,
                    true
                  );
                  //Select Traced Parts
                  var traceId = SquashNulls(
                    this.$.mainPhoto.photoData,
                    'photofirst_data',
                    page_linking.property,
                    page_linking.itemKey,
                    '_trace'
                  );
                  if (traceId != '' && this.$.mainPhoto.markers != null) {
                    for (var i = 0; i < this.$.mainPhoto.markers.length; i++) {
                      if (this.$.mainPhoto.markers[i].marker._trace == traceId) {
                        this.$.mainPhoto.set('markers.' + i + '.isSelected.parent', true);
                      }
                    }
                  }
                });
              } else if (page_linking.action_type === 'hardwareAngle') {
                // this.set('node1Id', page_linking.nodeId);
                this.setUpshotView(page_linking.nodeId, true);
                window.setTimeout(() => {
                  this.$.mainPhoto
                    .selectAnnotation(
                      page_linking.property,
                      page_linking.itemKey,
                      page_linking.property,
                      page_linking.itemKey,
                      null,
                      true,
                      true
                    )
                    .then(() => {
                      var traceId = SquashNulls(
                        this.$.mainPhoto.photoData,
                        'photofirst_data',
                        page_linking.property,
                        page_linking.itemKey,
                        '_trace'
                      );
                      for (let j = 0; j < this.$.mainPhoto.markers.length; j++) {
                        if (
                          (this.$.mainPhoto.markers[j].itemKey == page_linking.itemKey &&
                            this.$.mainPhoto.markers[j].property == page_linking.property) ||
                          this.$.mainPhoto.markers[j].marker._trace == traceId
                        ) {
                          this.$.mainPhoto.set('markers.' + j + '.isSelected.parent', true);
                        }
                      }
                    });
                });
              } else if (page_linking.setPowerSpec) {
                this.$.photoControls.set('setPowerSpec', page_linking.setPowerSpec);
                window.setTimeout(() => {
                  this.$.mainPhoto.selectAnnotation(
                    page_linking.property,
                    page_linking.itemKey,
                    page_linking.property,
                    page_linking.itemKey,
                    null,
                    true,
                    true
                  );
                });
              } else if (page_linking.action_type == 'equipmentSize') {
                this.$.photoControls.set('setEquipmentSize', page_linking.attribute_name);
                window.setTimeout(() => {
                  this.$.mainPhoto.selectAnnotation(
                    page_linking.property,
                    page_linking.itemKey,
                    page_linking.property,
                    page_linking.itemKey,
                    null,
                    true,
                    true
                  );
                  //Select Traced Parts
                  var traceId = SquashNulls(
                    this.$.mainPhoto.photoData,
                    'photofirst_data',
                    page_linking.property,
                    page_linking.itemKey,
                    '_trace'
                  );
                  if (traceId != '' && this.$.mainPhoto.markers != null) {
                    for (var i = 0; i < this.$.mainPhoto.markers.length; i++) {
                      if (this.$.mainPhoto.markers[i].marker._trace == traceId) {
                        this.$.mainPhoto.set('markers.' + i + '.isSelected.parent', true);
                      }
                    }
                  }
                });
              }
              this.dontClearActiveData = true;
              this.activeData = {
                key: page_linking.property,
                itemKey: page_linking.itemKey,
                photoId: photoId
              };
            }
            if (page_linking.action_type == 'cuEntry') {
              this.openCuEntryView(page_linking.workLocations, photoId);
            }
            if (page_linking.action_type == 'transferHeights') {
              if (page_linking.transferHeightData) {
                let e = { detail: page_linking.transferHeightData };
                window.setTimeout(() => {
                  this.openTransferHeights(e);
                }, 1000);
              }
            }
            if (photoId != 'null') {
              FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/photo_summary/${photoId}`).once(
                'value',
                function (snapshot) {
                  var photo = snapshot.val();
                  if (photo != null) {
                    if (page_linking.action_type != 'cuEntry' && page_linking.action_type != 'transferHeights') {
                      this.toggleView(null, 'photos');
                      if (page_linking.property != null) {
                        this.dontClearActiveData = true;
                        this.activeData = {
                          key: page_linking.property,
                          itemKey: page_linking.itemKey,
                          photoId: photoId
                        };
                      }
                      this.photo = photoId;
                    }
                  } else {
                    this.$.toast.show('Attempting to jump to photo that doesnt exist');
                  }
                }.bind(this)
              );
            }
          }

          if (page_linking.view == 'pci') {
            this.openPciRoutine();
          }

          if (
            page_linking.property !== 'down_guy' &&
            page_linking.property !== 'guying' &&
            !page_linking.photosToHighlight &&
            this.mode === 'hwDetail_DnGuy'
          ) {
            this.mode = null;
            this.$.photoControls.set('showDownGuyDetailToast', false);
          }
        }
        if (this.userData.active_trace != null) {
          if (this.removeUserDataTimeout) {
            clearTimeout(this.removeUserDataTimeout);
            this.removeUserDataTimeout = null;
          }
          // Check if we can switch the trace view before we do it
          this.canSwitchView().then((canSwitch) => {
            if (canSwitch) {
              this.jobId = this.userData.active_trace.job;
              this.midspanWarnings = [];
              this.node1IsLoaded = false;
              this.node2IsLoaded = false;
              this.connectionIsLoaded = false;
              this.connectedPhotoList = {
                connId: this.userData.active_trace.connection,
                photos: (this.userData.active_trace.connected_photos || []).map((x) => 'photos/' + x + '/photofirst_data')
              };
              if (this.userData.active_trace.connection == null) {
                // Setting these to undefined will cause their respective firebase-document bindings to stop computing (null was somehow pointing to a bad location in firebase..?)
                this.traceConnectionId = undefined;
                this.connectionIsLoaded = true;
                this.photo = null;
                // Get node keys and ignore loading if the key is null.
                if (!this.userData.active_trace.node_id_1) this.node1IsLoaded = true;
                if (!this.userData.active_trace.node_id_2) this.node2IsLoaded = true;
                this.node1Id = this.userData.active_trace.node_id_1;
                this.node2Id = this.userData.active_trace.node_id_2;
              } else if (this.traceConnectionId == this.userData.active_trace.connection) {
                this.connectionLoaded();
              } else {
                this.traceConnectionId = this.userData.active_trace.connection;
              }
              this.toggleView(null, 'trace');
              this.removeUserDataTimeout = window.setTimeout(() => {
                this.set('userData.active_trace', null);
                this.removeUserDataTimeout = null;
              }, 1000);
            }
          });
        }
        if (this.userData.mapTookLinkingAction == true) {
          this.$.photoControls.set('setPowerSpec', null);
          this.$.userData.ref.child('mapTookLinkingAction').remove();
        }
      }
    });
  }
  runLazyFunction(element, functionName, args) {
    if (element && typeof element[functionName] == 'function') {
      element[functionName].apply(element, args);
    }
  }
  traceConnectionIdChanged(e) {
    this.updateHash();
    if (!this.traceConnectionId) {
      this.connectedPhotoList = {};
    }
  }
  async viewChanged() {
    this.updateHash();
    if (this.view == 'photos') {
      this.set('traceSections', null);
    } else {
      this.photosAreLoaded = false;
    }
    if (this.view != 'upshot' && this.$.upshotMeasurement.set) {
      this.$.upshotMeasurement.set('showUpshotMeasurementButtons', false);
    }
    if (this.$.photoLibrary.cancelClicked) {
      this.$.photoLibrary.cancelClicked();
    }
    this.cableTracing = this.view === 'trace';
    if (this.view === 'pci') {
      await import('../pci-routine/pci-routine.js');
    }
  }
  enableMakeReady() {
    this.showClearances = true;
  }
  toggleCableTracing(e) {
    e.currentTarget.active = this.view === 'trace';
    this.canSwitchView().then((canSwitch) => {
      if (canSwitch) {
        if (this.view === 'photos') this.toggleView(null, 'trace');
        else if (this.view === 'trace') {
          this.toggleView(null, 'photos');
          this.$.mainPhoto.focus();
        }
      }
    });
  }
  confirmEvent(e) {
    if (e.detail.otherButtons) {
      e.detail.otherButtons.forEach((button) => (button.callback = e.currentTarget[button.callback].bind(e.currentTarget)));
    }
    this.$.photoControls.confirm(
      e.detail.heading,
      e.detail.body,
      e.detail.affirmativeText,
      e.detail.dismissiveText,
      e.detail.affirmativeStyle,
      e.detail.confirmDialogBodyType,
      (e.currentTarget[e.detail.callback] || function () {}).bind(e.currentTarget),
      (e.currentTarget[e.detail.cancelCallback] || function () {}).bind(e.currentTarget),
      e.detail.otherButtons
    );
  }
  exitView() {
    this.canSwitchView().then((canSwitch) => {
      if (canSwitch) {
        if (['transferHeights', 'pci'].includes(this.view)) {
          this.$.photoControls.quitExtractionLoop();
        }
        this.toggleView(null, this.traceConnectionId != null ? 'trace' : 'photos');
      }
    });
  }
  canSwitchView() {
    return new Promise((resolve, reject) => {
      // If we are in trace view, are about to switch to a different view,
      // and we are not in read only mode, then check for any malformed data
      // before switching the view
      if (this.isView(null, 'trace') && !this.locked && !SquashNulls(this.modelConfig, 'skip_switch_view_check')) {
        this.$.photoControls.checkForMalformedData().then((warnings) => {
          // Filter out all "Pole Top not fully traced" warnings
          warnings = warnings.filter((item) => !(item.warning.includes('Pole Top') && item.warning.includes('not fully traced')));

          if (warnings && warnings.length > 0) {
            this.$.photoControls.switchTraceViewWarnings = warnings;

            this.$.photoControls.confirm(
              'Trace View Warnings',
              'Are you sure you want to leave the trace view? This span has not been properly traced.',
              'Stay',
              'Leave',
              'var(--secondary-color)',
              'switchTraceViewWarning',
              () => {
                // Resolve the promise and say that we should not switch the view
                // because the user said to stay
                resolve(false);
              },
              () => {
                // Resolve the promise and say that we should switch the view
                // because the user said to switch anyway
                resolve(true);
              }
            );
          } else {
            resolve(true);
          }
        });
      } else {
        // Switch the view because we are not in a scenario where we shouldn't switch
        resolve(true);
      }
    });
  }
  // This function should only be called after calling canSwitchView
  // and you get a confirmation to switch the view back
  toggleView(e, view) {
    if (['trace', 'photos', 'upshot', 'cuEntry', 'transferHeights', 'pci'].indexOf(view) != -1) {
      this.view = view;
    } else {
      this.view = e.currentTarget.getAttribute('name');
    }
    if (this.view == 'photos') {
      if (this.photoSummary && this.photo && !this.get(`photoSummary.${this.photo}`) && this.view == 'photos') {
        this.photo = this.filteredPhotoKeys[0];
        this.$.toast.show('Switched to first photo.');
      } else {
        this.photoChanged();
      }
    } else if (this.view == 'trace') {
      this.connectionLoaded();
      // Have choosers re-select their photos.
      var choosers = this.shadowRoot.querySelectorAll('katapult-photo-chooser');
      for (var i = 0; i < choosers.length; i++) {
        choosers[i].filterPhotos();
      }
    }
  }

  updateJobLocking() {
    if (this.cachedJobLocked === this.metadata?.job_locked || this.metadata?.job_locked == null) return;
    this.cachedJobLocked = this.metadata?.job_locked;
    this.lockPhotoOnLoad();
  }

  lockPhotoOnLoad() {
    // Read only users and companies without write permission to the job should not be able to edit a job
    if (this.readOnlyUser || this.sharing != 'write') {
      this.locked = true;
      return;
    }

    // If the user's company has job locking feature enabled, the job's job_locked attribute should be used instead of the job's status
    if (this.enabledFeatures.job_locking) {
      this.locked = Boolean(this.metadata?.job_locked);
    } else {
      this.locked = Boolean(this.jobStatus?.published);
    }
  }

  async toggleLocked() {
    if (this.enabledFeatures.job_locking) {
      // only users that have unlocking permission can unlock a job
      if (this.locked) {
        // get the job unlocking permissions
        let uid = this.user.uid;
        let canUnlockJob = await FirebaseWorker.ref(`users/${this.userGroup}/${uid}/roles/photoheight/permissions/job_unlocking_access`)
          .once('value')
          .then((s) => s.val());
        if (canUnlockJob) this.locked = !this.locked;
        else {
          // show a confirmation when locking a job so that they know they may not be able to unlock it
          KatapultDialog.alert({
            dialog: { title: 'Job Unlocking Denied' },
            body: `You don't have permission to unlock this job. This permission can be granted in the admin page.`
          });
        }
      }
      // any write user should be able to lock a job
      else {
        // show a confirmation when locking a job so that they know they may not be able to unlock it
        const dialogConfig = KatapultDialog.confirm({
          dialog: { title: 'Job Locking Confirmation' },
          body: 'Are you sure you want to lock this job? Only users with the permission to unlock jobs will be able to unlock this job. This permission can be granted in the admin page.',
          confirmButton: { label: 'Lock' }
        });
        const didConfirm = await dialogConfig.confirmed;
        // If the user confirmed, lock the job
        if (didConfirm) this.locked = !this.locked;
      }
    } else {
      // do the default locking action
      if (this.readOnlyUser !== true && this.sharing == 'write') this.locked = !this.locked;
    }
  }
  toggleShowSag() {
    this.showSag = !this.showSag;
    this.showClearances = false;
  }
  toggleShowClearances() {
    this.showClearances = !this.showClearances;
    this.showSag = false;
  }
  openChooser(e) {
    let item = e.currentTarget.item;
    this.shadowRoot.querySelectorAll('katapult-photo-chooser').forEach((chooser) => {
      if (
        (item.nodeId && SquashNulls(chooser, 'item', 'nodeId') == item.nodeId) ||
        (item.connId &&
          SquashNulls(chooser, 'item', 'connId') == item.connId &&
          SquashNulls(chooser, 'item', 'sectionId') == item.sectionId)
      ) {
        chooser.toggle();
      }
    });
  }
  openUpshotView(e) {
    this.setUpshotView(e.currentTarget.item.nodeId);
  }
  async openCuEntryView(workLocations, photoId) {
    await import('../cu-entry/cu-entry.js');
    let index = 0;
    if (photo) index = workLocations.findIndex((x) => x.photoId == photoId);
    this.showClearances = true;
    this.toggleView(null, 'cuEntry');
    this.$.cuEntry.open(workLocations, index);
  }
  async openPciRoutine() {
    if (await this.canSwitchView()) {
      this.toggleView(null, 'pci');
      this.showClearances = true;
      this.locked = false;
      this.photo = null;
    }
  }
  clearedMarkers(e) {
    if (this.view == 'transferHeights') {
      FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/photos/${this.photoRight}`).update({
        inherited_photo_id: null,
        interpolate_only: null
      });
      let e = { detail: { transferFrom: this.photoLeft, item: { nodeId: this.node1Id }, transferTo: this.photoRight } };
      this.openTransferHeights(e);
    }
  }
  openTransferHeights(e) {
    let viewer = this.$.photoControls.photoViewerLookup[e.detail.transferFrom];
    if (viewer.markers != null) {
      let items = [];
      let warningHeights = Object.values(viewer.warningHeights || {});
      let photoViewerLeft = this.shadowRoot.querySelector('#photoLeft');
      // Loop through the markers in the viewer
      viewer.markers.forEach((marker, markerIndex) => {
        let measuredHeight = SquashNulls(marker.marker, '_measured_height');
        var itemHeight = measuredHeight || SquashNulls(marker.marker, '_manual_height');
        var move = parseFloat(marker.marker.mr_move) || 0;
        if (itemHeight && move == 0 && (!measuredHeight || warningHeights.every((x) => x > measuredHeight))) {
          items.push({
            viewer: photoViewerLeft,
            rootMarker: marker,
            item: marker.marker,
            itemHeight,
            markerIndex,
            property: marker.property,
            key: marker.itemKey
          });
        }
      });
      items.sort((a, b) => b.itemHeight - a.itemHeight);
      this.heightsTransfered = false;
      this.toggleView(null, 'transferHeights');
      this.photoLeft = e.detail.transferFrom;
      this.photo = null;
      this.node1Id = e.detail.item.nodeId;
      this.photoRight = e.detail.transferTo;
      this.node2Id = e.detail.item.nodeId;
      setTimeout(() => {
        this.$.photoControls.inExtractionLoop = true;
        this.$.photoControls.traceableItems = items;
        this.$.photoControls.traceableItemsQueue = [];
        this.$.photoControls.extractionHighlightNextItem();
      }, 500);
    }
  }
  showTransferHeights(view, heightsTransfered) {
    return view == 'transferHeights' && !heightsTransfered;
  }
  transferHeightMarkers(options) {
    options = options || {};
    this.heightsTransfered = true;
    this.$.photoControls.quitExtractionLoop();

    // TODO: Not sure if we need this anymore?
    let multiSelectedMarkers = this.shadowRoot.querySelector('#photoLeft').markers.filter((x) => x.multiSelected);
    if (multiSelectedMarkers.length > 0) {
      this.$.photoControls.selectedMarkersTransferAt = this.$.photoControls.selectedMarkersTransferAt || 'proposed';
      this.$.photoControls.otherMarkersTransferAt = this.$.photoControls.otherMarkersTransferAt || 'proposed';
      this.$.photoControls.confirm(
        'Transfer at existing or proposed heights?',
        null,
        'Transfer',
        'Cancel',
        'background-color:var(--secondary-color); color:white',
        'transferHeights',
        async () => {
          options.selectedMarkersTransferAt = this.$.photoControls.selectedMarkersTransferAt;
          options.otherMarkersTransferAt = this.$.photoControls.otherMarkersTransferAt;
        }
      );
    }

    this.runTransferHeightMarkers(options);
  }
  async runTransferHeightMarkers(options) {
    options = options || {};
    let update = {};
    let ref = FirebaseWorker.ref('photoheight');
    let traceIdList = {};
    let photoId = this.photoRight;
    let photoLeft = this.shadowRoot.querySelector('#photoLeft');

    // TODO: Not sure if we need this anymore.
    let multiSelectedMarkers = {};
    photoLeft.markers.forEach((marker) => {
      if (marker.multiSelected) multiSelectedMarkers[marker.itemKey] = true;
    });

    let fromPhotoData = photoLeft.photoData;
    let toPhotoData = this.shadowRoot.querySelector('#photoRight').photoData;
    if (!toPhotoData.stick_align) {
      this.$.toast.show('Cannot transfer heights to an uncalibrated photo.');
      return;
    }
    const keyLookup = {};
    for (let property in fromPhotoData.photofirst_data) {
      if (property[0] != '_' && property != 'anchor_calibration') {
        for (let itemKey in fromPhotoData.photofirst_data[property]) {
          let marker = fromPhotoData.photofirst_data[property][itemKey];
          if (marker.pixel_selection) {
            let newMarkerKey = ref.push().key;
            let newMarker = JSON.parse(JSON.stringify(marker));
            let originalHeight = newMarker._measured_height != null ? newMarker._measured_height : newMarker._manual_height;
            let proposedHeight = Round(originalHeight + (parseFloat(newMarker.mr_move) || 0), 2);
            if (!this.validationRoutine) {
              newMarker.original_height = FormatHeight(originalHeight, this.useMetricUnits == true ? 'meters' : 'feet-inches', 2);
              newMarker.proposed_height = FormatHeight(proposedHeight, this.useMetricUnits == true ? 'meters' : 'feet-inches', 2);
            }

            let newHeight = originalHeight;

            // add a reference to the original marker key so we can link them in the future
            newMarker._original_marker_key = itemKey;

            if (
              options.applyMrMoves ||
              (options.selectedMarkersTransferAt == 'proposed' && multiSelectedMarkers[itemKey]) ||
              (options.otherMarkersTransferAt == 'proposed' && !multiSelectedMarkers[itemKey])
            ) {
              newHeight = proposedHeight;
              if (newMarker.proposed_ground || newMarker.proposed_ground_rod) newMarker.grounded = true;
              // Delete make ready attributes since we are applying make ready.
              for (const attribute in this.alternateDesignsConfig?.marker_attributes) {
                newMarker[attribute] = KLogic.compute(this.alternateDesignsConfig?.marker_attributes[attribute]);
              }
              TraverseMarkers(newMarker._children, (child, childPath, property, itemKey) => {
                if (child.proposed_ground || child.proposed_ground_rod) child.grounded = true;
                // Loop through all marker attributes.
                for (const attribute in this.alternateDesignsConfig?.marker_attributes) {
                  child[attribute] = KLogic.compute(this.alternateDesignsConfig?.marker_attributes[attribute]);
                }
              });
            }
            delete newMarker._manual_height;
            delete newMarker.manual_height;

            // Delete out the _pci_ignore_anchor flag from the new marker, but we don't want to delete
            // it from the original marker because we have no other record of that original marker
            // ever being proposed or not.
            delete newMarker._pci_ignore_anchor;

            var pixelsForHeight = calibratePhoto.getPixel(newHeight, toPhotoData.stick_align);
            newMarker.pixel_selection = {
              0: {
                percentX: (pixelsForHeight.x / toPhotoData.stick_align.width) * 100,
                percentY: (pixelsForHeight.y / toPhotoData.stick_align.height) * 100
              }
            };
            newMarker._measured_height = newHeight;
            if (newMarker._children) {
              this.$.photoControls.getNewChildKeys(newMarker, ref, update, property, newMarkerKey, traceIdList, photoId, {
                keepAttributes: true
              });
            } else if (newMarker._trace) {
              update[
                '/jobs/' + this.jobId + '/traces/trace_items/' + newMarker._trace + '/' + photoId + '/' + property + '/' + newMarkerKey
              ] = true;
            }
            update['jobs/' + this.jobId + '/photos/' + photoId + '/photofirst_data/' + property + '/' + newMarkerKey] = newMarker;
            keyLookup[itemKey] = newMarkerKey;
          }
        }
      }
    }
    // Update the main photo unless we are in the validation routine
    if (!this.validationRoutine) {
      // Update association for photos on this node.
      let path = '/association';

      // Determine if we're editing a node's photo data or a section's photoData
      let itemPath;
      if (options.pci) {
        if (this.activePciItemData.isMidspan) {
          itemPath = `connections/${this.activePciItemData.connId}/sections/${this.activePciItemData.sectionId}`;
        } else {
          itemPath = `nodes/${this.activePciItemData.$key}`;
        }
      } else {
        // if we're not in pci, we want to set the path to the default, which is nodes/this.node1Id
        itemPath = `nodes/${this.node1Id}`;
      }

      // Set up the log object to log data for a bug in the PCI routine where photos are being associated to multiple nodes.
      const data = structuredClone(this.activePciItemData);
      data.photoLeft = structuredClone(photoLeft.item);
      data.photoRight = this.photoRight;
      data.photos = {};

      for (let id in photoLeft.item.photos) {
        let photo = photoLeft.item.photos[id];

        // This code is added to log data for a bug in the PCI routine where photos are being associated to multiple nodes. This a bandaid fix until we find the real culprit.
        if (options.pci) {
          const photoDataAssociatedLocations = await FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/photos/${id}/associated_locations`)
            .once('value')
            .then((s) => s.val());

          if (!photoDataAssociatedLocations?.[this.activePciItemData.$key]) {
            // If the photo is not associated to the current node (the node thinks it is), log the data.
            data.photos[id] = {
              associated_locations: photoDataAssociatedLocations
            };
            continue;
          }
        }

        // Default association value to true.
        let value = true;
        // Set association to old_main if this is a pre-construction photo that is labeled as main or this is an already old_main photo.
        if (
          ((photo == 'main' || photo.association == 'main') && photo.pre_construction) ||
          photo == 'old_main' ||
          photo.association == 'old_main'
        )
          value = 'old_main';
        update[`jobs/${this.jobId}/${itemPath}/photos/${id}/${path}`] = value;
      }

      // Check if we have any data for the logs and if we do, write it to the database
      if (Object.keys(data.photos).length > 0) {
        data.key = data.$key ?? null;
        delete data.$key;
        data.photoLeft.key = data.photoLeft.$key ?? null;
        delete data.photoLeft.$key;
        for (const [photoId, photo] of Object.entries(data.photoLeft.photos ?? {})) {
          photo.key = photo.$key ?? null;
          delete photo.$key;
        }
        FirebaseWorker.ref(`photoheight/pci_logs/${this.jobId}/${itemPath}`).update(data);
      }

      // Set photo we transfered heights to as the new main photo.
      update[`jobs/${this.jobId}/${itemPath}/photos/${this.photoRight}/${path}`] = 'main';

      // Set PCI Extraction Complete attribute on node.
      if (options.pci) {
        if (!this.activePciItemData?.isMidspan) update[`jobs/${this.jobId}/${itemPath}/attributes/PCI_extraction_complete/auto`] = true;
        else update[`jobs/${this.jobId}/${itemPath}/multi_attributes/PCI_extraction_complete/auto`] = true;
      }
    }
    // If we are in the validation routine, copy the alternate designs, only if we have chosen not to apply the mr moves
    if (options.pci && this.validationRoutine && !options.applyMrMoves) {
      const alternateDesigns = structuredClone(fromPhotoData.alternate_designs ?? {});
      for (const key in alternateDesigns?.designs) {
        for (const prop in alternateDesigns?.designs[key].data?.photo?.photofirst_data) {
          Object.entries(alternateDesigns.designs[key].data?.photo?.photofirst_data[prop] ?? {}).forEach(([itemKey, marker]) => {
            alternateDesigns.designs[key].data.photo.photofirst_data[prop][keyLookup[itemKey]] = marker;
            delete alternateDesigns.designs[key].data.photo.photofirst_data[prop][itemKey];
          });
        }
      }
      this.removeKey(alternateDesigns, '$key');
      update[`jobs/${this.jobId}/photos/${photoId}/alternate_designs`] = alternateDesigns;
    }

    FirebaseWorker.ref('photoheight').update(update);
  }
  removeKey(obj, key) {
    for (const prop in obj) {
      if (prop === key) {
        delete obj[prop];
      } else if (typeof obj[prop] === 'object') {
        this.removeKey(obj[prop], key);
      }
    }
  }
  setUpshotView(nodeId, hideUpshotMeasurementButtons, property, itemKey) {
    this.toggleView(null, 'upshot');
    this.$.upshotMeasurement.set('totalUpshotMeasurement', 0);
    this.$.upshotMeasurement.set('upshotMeasurements', {});
    var photos;

    if (this.node1Id == nodeId) {
      photos = this.node1.photos;
    } else if (this.node2Id == nodeId) {
      photos = this.node2.photos;
    }

    if (photos) {
      var paths = [];
      var mainPhotoId = null;
      for (var photoId in photos) {
        if (photos[photoId] == 'main' || photos[photoId].association == 'main') {
          mainPhotoId = photoId;
        } else {
          paths.push('photos/' + photoId + '/photofirst_data/upshot');
        }
      }
      if (mainPhotoId) {
        var photo = this.$.photoControls.photoViewerLookup[mainPhotoId].photoData;
        var upshots = [];
        GetJobData(this.jobId, paths).then((data) => {
          for (var key in data) {
            if (data[key] != null) {
              var photoId = key.split('/')[1];
              var height = SquashNulls(photo, 'photofirst_data', property, itemKey, '_measured_height') || null;
              if (height != null) height = Math.round((100 * height) / 12) / 100;
              upshots.push({ key: photoId, measurement: { pixel_selection: [] }, objectHeight: height, cameraHeight: 6 });
            }
          }
          this.set('photo', mainPhotoId);
          this.$.upshotMeasurement.set('upshots', upshots);
          this.$.upshotMeasurement.set('showUpshotMeasurementButtons', !hideUpshotMeasurementButtons);
        });
      }
    }
  }
  markerSelected(e) {
    if (this.view == 'cuEntry') {
      this.$.cuEntry.markerId = e.detail.itemKey;
    }
    // add data about the selection to the 3d view data
    this.updateThreeDViewSelectedTraceData(e);
  }
  updateThreeDViewSelectedTraceData(e) {
    // get the trace of the marker that was selected
    const photoData = e.currentTarget.photoData?.photofirst_data;
    const pathToItem = `${e.detail.path}/${e.detail.itemKey}`;
    const markerData = Path.get(photoData, pathToItem, '/');
    const traceId = markerData?._trace;

    // build the selected trace data
    const selectedTraceData = { traceId };

    // get the connection id for the trace based on if the current item is a section or node
    const currentItem = e.currentTarget.item;
    const isSection = currentItem.sectionId != null;
    // add the connection id or the node id to the trace data depending on the item type
    if (isSection) {
      const connectionId = currentItem.connId;
      if (!connectionId) return;
      selectedTraceData.connectionId = connectionId;
    } else {
      const nodeId = currentItem.$key ?? currentItem.nodeId;
      if (!nodeId) return;
      selectedTraceData.nodeId = nodeId;
    }

    // add the selected id to the 3d view data
    if (!traceId || !this.userGroup || !this.user?.uid) return;
    const threeDViewUpdate = { selectedTraceData, setBy: 'maps' };
    FirebaseWorker.ref('photoheight/company_space/' + this.userGroup + '/user_data/' + this.user.uid + '/3d_view_data').update(
      threeDViewUpdate
    );
  }
  markerDeselected(e) {
    if (this.view == 'cuEntry') {
      this.$.cuEntry.markerId = null;
    }
  }
  calcChooserScale(e) {
    if (this.$.photoLibrary.calcChooserScale) {
      this.$.photoLibrary.calcChooserScale(e);
    }
  }
  toggleShowInfoPanel() {
    this.showInfoPanel = !this.showInfoPanel;
  }
  traceIsSelected(view, connectionId, connection) {
    if (view == 'trace' && connectionId != null && connection != null) {
      return true;
    } else {
      return '';
    }
  }
  connectionLoaded() {
    if (this.traceConnectionId != null && this.connection != null) {
      this.connectionIsLoaded = true;
      if (this.node1Id != this.connection.node_id_1) {
        this.node1Id = this.connection.node_id_1;
      } else {
        this.node1IsLoaded = true;
      }
      if (this.node2Id != this.connection.node_id_2) {
        this.node2Id = this.connection.node_id_2;
      } else {
        this.node2IsLoaded = true;
      }
      this.setLeftRightPhoto();
    }
  }
  node1Loaded() {
    if (this.node1 != null && this.view != 'photo') {
      this.node1IsLoaded = true;
      this.setLeftRightPhoto();
    }
  }
  node2Loaded() {
    if (this.node2 != null && this.view != 'photo') {
      this.node2IsLoaded = true;
      this.setLeftRightPhoto();
    }
  }
  setLeftRightPhoto() {
    if (this.node1IsLoaded && this.node2Id == null && this.connectionId == null) {
      this.node1.nodeId = this.node1Id;
      this.set('leftNode', this.node1);
    } else if (this.view == 'pci' && this.node1IsLoaded && this.node2IsLoaded) {
      this.setLeftRightNodes(1);
    } else if (this.node1IsLoaded && this.node2IsLoaded && this.connectionIsLoaded && this.node1 && this.node2) {
      const node1 = this.node1;
      const node2 = this.node2;
      const default_vantage = [40.10521, -77.023162];
      const vantage1 = PickAnAttribute(node1?.attributes, 'vantage_point') || {
        latitude: default_vantage[0],
        longitude: default_vantage[1]
      };
      const vantage2 = PickAnAttribute(node2?.attributes, 'vantage_point') || {
        latitude: default_vantage[0],
        longitude: default_vantage[1]
      };
      let theta = 0;
      let phi = null;
      let alpha = null;
      let beta = null;
      // calculate node2's bearing in relation to node1
      if (node1.latitude && node1.longitude && node2.latitude && node2.longitude)
        theta = KatapultGeometry.CalcBearing(node1.latitude, node1.longitude, node2.latitude, node2.longitude);
      // find the minimum for the range that is on the same side
      // the range [phi, theta] includes all bearings on the same side
      // the range [-phi, -theta] includes all bearings on the opposite side
      // the endpoints can be included in both ranges
      if (theta >= 180) {
        phi = theta - 180;
      } else {
        phi = theta + 180;
      }

      // calculate the bearing from node1 to node1's vantage point
      if (vantage1 != null) alpha = KatapultGeometry.CalcBearing(node1.latitude, node1.longitude, vantage1.latitude, vantage1.longitude);
      // calculate the bearing from node2 to node2's vantage point
      if (vantage2 != null) beta = KatapultGeometry.CalcBearing(node2.latitude, node2.longitude, vantage2.latitude, vantage2.longitude);
      // if either node doesn't have a vantage point, set it to the other's if it exists
      if (vantage1 == null && beta) {
        alpha = beta;
      }
      if (vantage2 == null && alpha) {
        beta = alpha;
      }
      // determine if the bearings are on the same side or not
      if (alpha && beta) {
        let sameSide = 0;
        if (phi < theta) {
          sameSide = this.determineSameSide(phi, theta, alpha, beta);
        } else {
          sameSide = this.determineSameSide(theta, phi, alpha, beta);
        }
        switch (sameSide) {
          case 1:
            // vantage points above line determined by connection
            if (vantage1 != null) {
              this.determineLeftRight(node1, vantage1, alpha, node2);
            } else {
              this.determineLeftRight(node2, vantage2, beta, node1);
            }
            break;
          case -1:
            // vantage points below line determined by connection
            if (vantage1 != null) {
              this.determineLeftRight(node1, vantage1, alpha, node2);
            } else {
              this.determineLeftRight(node2, vantage2, beta, node1);
            }
            break;
          default:
            // vantage points are on different sides
            this.setLeftRightNodes(1);
        }
      } else {
        // no vantage points exist
        this.setLeftRightNodes(1);
      }
    }
  }
  activePciItemDataChanged(activePciItem) {
    if (activePciItem) {
      this.leftNode = activePciItem;
      this.rightNode = activePciItem;
    } else {
      this.leftNode = null;
      this.rightNode = null;
    }
  }
  determineSameSide(bearingA, bearingB, alpha, beta) {
    if (alpha >= bearingA && alpha <= bearingB && beta >= bearingA && beta <= bearingB) {
      // vantage points on same side
      return -1;
    } else if ((alpha <= bearingA || alpha >= bearingB) && (beta <= bearingA || beta >= bearingB)) {
      // vantage points on same side
      return 1;
    } else {
      // vantage points on different side
      return 0;
    }
  }
  determineLeftRight(node1, vantage1, alpha, node2) {
    // change our perspective imagining we're looking at a unit circle where vantage1 is at the origin (0,0) and node1 is at (0,1)
    // then we calculate the bearing from vantage1 to node2 and take the cosine
    // a positive result means node1 is on the left
    // a negative result means node1 is on the right

    // calculate bearing from vantage1 to node2
    let gamma = KatapultGeometry.CalcBearing(vantage1.latitude, vantage1.longitude, node2.latitude, node2.longitude);
    // rotate our perspective as outlined above
    if (alpha < 180) {
      gamma += 180 - alpha;
    } else {
      gamma -= alpha - 180;
    }
    // calculate the cosine of gamma changing gamma to radians
    // don't forget the bearing is already rotated by 90 degrees so account for that too
    const sign = Math.cos(((gamma - 90) * Math.PI) / 180);
    if (sign >= 0) {
      // node1 is the left node
      this.setLeftRightNodes(1);
    } else {
      // node1 is the right node
      this.setLeftRightNodes(-1);
    }
  }
  joinArrays(array1, array2, joinString) {
    var newArray = [];
    var maxLength = array1.length > array2.length ? array1.length : array2.length;
    for (var i = 0; i < maxLength; i++) {
      var one = i < array1.length ? array1[i] : '';
      var two = i < array2.length ? array2[i] : '';
      newArray.push(one.toString() + joinString + two.toString());
    }
    return newArray;
  }
  getLabelFromNode(node) {
    var scid = node ? PickAnAttribute(node.attributes, 'scid') : null;
    return scid == null ? '(No SCID)' : 'SCID ' + scid.toString();
  }
  photoDataLoaded(e) {
    if (this.view == 'trace') {
      var warnings = this.getWarnings(e.currentTarget.photoData);
      if (warnings.length > 0) {
        this.midspanWarnings = (this.midspanWarnings || []).concat(warnings);
        this.$.unknownWarnings.open();
      }
    }
    // once the photo data is photo loaded, setup them up for manual resize
    this.setupManualPhotoResize();
  }
  getWarnings(photoData) {
    var warnings = [];
    var midspanHeight = SquashNulls(photoData, 'photofirst_data', 'midspanHeight');
    var count = 0;
    for (var key in midspanHeight) {
      count++;
      if (midspanHeight[key].over == 'Driveway/Roadway' || midspanHeight[key].over == 'Unknown') {
        warnings.push('Midspan marked as ' + midspanHeight[key].over + '.');
      }
    }
    if (count > 1) {
      warnings.push('Too many midspan classifications on section photo.');
    }
    return warnings;
  }
  setLeftRightNodes(sign) {
    if (!this.node1 || !this.node2) return;
    let shouldResetPositions = true;

    // Check if the existing left and right node ids match the new node1Id
    // and node2Id, and if so, don't allow the swap code to run, so that we
    // don't reset left and right photos if they are already set
    if (this.leftNode && this.rightNode) {
      if (this.leftNode.nodeId == this.node1Id || this.leftNode.nodeId == this.node2Id) {
        if (this.rightNode.nodeId == this.node1Id || this.rightNode.nodeId == this.node2Id) {
          shouldResetPositions = false;
        }
      }
    }

    if (shouldResetPositions) {
      if (sign == 1) {
        if (this.node1Id && this.node1) {
          this.node1.nodeId = this.node1Id;
          this.set('leftNode', this.node1);
        } else {
          this.set('leftNode', null);
        }
        if (this.node2Id && this.node2) {
          this.node2.nodeId = this.node2Id;
          this.set('rightNode', this.node2);
        } else {
          this.set('rightNode', null);
        }
      } else {
        if (this.node2Id && this.node2) {
          this.node2.nodeId = this.node2Id;
          this.set('leftNode', this.node2);
        } else {
          this.set('leftNode', null);
        }
        if (this.node1Id && this.node1) {
          this.node1.nodeId = this.node1Id;
          this.set('rightNode', this.node1);
        } else {
          this.set('rightNode', null);
        }
      }
    } else {
      // Update the data for the left and right nodes, but don't change the positions
      this.node1.nodeId = this.node1Id;
      this.node2.nodeId = this.node2Id;
      if (this.leftNode.nodeId == this.node1Id) {
        // when we are in pci view we don't need to update the value for the left node since it is the old photo
        if (this.view != 'pci') {
          this.set('leftNode', this.node1);
        }

        this.set('rightNode', this.node2);
      } else {
        this.set('leftNode', this.node2);
        this.set('rightNode', this.node1);
      }
    }

    this.setPhotos(sign);
  }
  getSCIDLabel(node) {
    var scid = PickAnAttribute(node.attributes, 'scid');
    return scid == null ? '(No SCID)' : 'SCID ' + scid.toString();
  }
  calcDistanceRatios(section) {
    let distanceRatios = {};
    let rightLocation, leftLocation, totalDistance;
    let sectionLocation = new GoogleGeometry.maps.LatLng(section.latitude, section.longitude);
    if (this.rightNode && this.leftNode) {
      rightLocation = new GoogleGeometry.maps.LatLng(this.rightNode.latitude, this.rightNode.longitude);
      leftLocation = new GoogleGeometry.maps.LatLng(this.leftNode.latitude, this.leftNode.longitude);
      totalDistance = GoogleGeometry.maps.geometry.spherical.computeLength([rightLocation, leftLocation]);
    }
    // Set the distance ratios on the sections based on the left and right photo ids
    if (this.leftNode && this.leftNode.photos) {
      let leftPhotoId = GetMainPhoto(SquashNulls(this.leftNode, 'photos'));
      distanceRatios[leftPhotoId] =
        1 - GoogleGeometry.maps.geometry.spherical.computeLength([sectionLocation, leftLocation]) / totalDistance;
    }
    if (this.rightNode && this.rightNode.photos) {
      let rightPhotoId = GetMainPhoto(SquashNulls(this.rightNode, 'photos'));
      distanceRatios[rightPhotoId] =
        1 - GoogleGeometry.maps.geometry.spherical.computeLength([sectionLocation, rightLocation]) / totalDistance;
    }
    return distanceRatios;
  }
  setPhotos(sign) {
    var sections = [];
    if (this.traceConnectionId && this.connection) {
      for (var sectionKey in this.connection.sections) {
        var section = { sectionId: sectionKey };
        section.connId = this.traceConnectionId;
        section.conn = this.connection;
        section.photos = this.connection.sections[sectionKey].photos;
        section.mainPhoto = GetMainPhoto(section.photos);
        section.latitude = Number(this.connection.sections[sectionKey].latitude);
        section.longitude = Number(this.connection.sections[sectionKey].longitude);
        section.multi_attributes = this.connection.sections[sectionKey].multi_attributes;
        section.distanceRatios = this.calcDistanceRatios(section);
        section.sectionPosition = KatapultGeometry.CalcDistance(
          this.leftNode.latitude,
          this.leftNode.longitude,
          section.latitude,
          section.longitude
        );
        sections.push(section);
      }
    }
    sections.sort(function (a, b) {
      return a.sectionPosition - b.sectionPosition;
    });
    // Pull out the first section and put it into the "mainPhoto" viewer.
    var firstSection = sections.shift();
    if (firstSection != null) {
      this.set('mainPhotoItem', firstSection);
      if (firstSection.photos) {
        const mainPhotoId = GetMainPhoto(firstSection.photos);
        if (mainPhotoId) {
          this.photo = mainPhotoId;
        }
      }
    } else {
      this.set('mainPhotoItem', null);
      this.photo = '';
    }

    this.set('traceSections', sections);
    this.reOrientateImage = true;
    this.reOrientateImages();
    // Have choosers re-select their photos.
    setTimeout(() => {
      var choosers = this.shadowRoot.querySelectorAll('katapult-photo-chooser');
      for (var i = 0; i < choosers.length; i++) {
        choosers[i].filterPhotos();
      }
    }, 1);
  }

  jobIdChanged() {
    this.updateHash();
    this.photosAreLoaded = false;
    if (!this.jobId) {
      this.toggleView(null, 'photos');
      this.photo = null;
      this.mode = null;
      this.traceConnectionId = undefined;
    }
  }
  jobNameChanged() {
    if (this.jobName) {
      document.title = `${this.jobName} - ${this.config.firebaseData.name} Photos`;
    } else {
      document.title = `${this.config.firebaseData.name} Photos`;
    }
  }
  getPhotoCount(photo, filteredPhotoKeys) {
    var currentPhotoCount = 0;
    for (var i = 0; i < filteredPhotoKeys.length; i++) {
      if (photo == filteredPhotoKeys[i]) {
        currentPhotoCount = i + 1;
        break;
      }
    }
    return currentPhotoCount;
  }
  getSyncedTime() {
    if (this.mainPhotoDataLoaded) {
      var photo = this.$.mainPhoto.photoData;
      if (photo != null) {
        var syncedTime = photo.synced_time;
        if (syncedTime != null) {
          return '(' + this.formatTime(syncedTime) + ')';
        }
      }
    }
    return '';
  }
  getPhotoName() {
    if (this.mainPhotoDataLoaded) {
      var photoData = this.$.mainPhoto.photoData;
      if (photoData) {
        return photoData.filename;
      }
    }
    return '';
  }
  formatTime(time) {
    if (time == null) {
      return '';
    }
    var date = new Date(time);
    var hours = ('0' + date.getHours()).slice(-2);
    var minutes = ('0' + date.getMinutes()).slice(-2);
    var seconds = ('0' + date.getSeconds()).slice(-2);
    return hours + ':' + minutes + ':' + seconds;
  }
  selectAllPhotos(e) {
    this.selectedPhotos = this.filteredPhotoKeys;
  }
  async sortPhotos(e) {
    let sortType = e.currentTarget.dataset.key;

    var ref = FirebaseWorker.ref('photoheight/jobs/' + this.jobId);
    let jobPhotos = await GetJobData(this.jobId, 'photos').then((data) => data.photos || null);

    let photosToSort = {};
    for (var i = 0; i < this.selectedPhotos.length; i++) {
      let key = this.selectedPhotos[i];
      photosToSort[key] = jobPhotos[key];
    }

    const newPhotoSummary = structuredClone(this.photoSummary);
    for (var photoId in photosToSort) {
      let photofirst_data = SquashNulls(photosToSort[photoId], 'photofirst_data');
      let newPriority = this.getPhotoPriority(photoId, photosToSort, sortType, photofirst_data);
      if (newPriority && newPhotoSummary[photoId]) {
        newPhotoSummary[photoId]['.priority'] = newPriority;
      }
    }

    ref.child('/photo_summary').set(newPhotoSummary, (e) => {
      if (e) console.log('error', e);
      else {
        if (sortType == 'name') this.$.toast.show(`${this.selectedPhotos.length} Photos sorted by file name.`);
        else if (sortType == 'sync') this.$.toast.show(`${this.selectedPhotos.length} Photos sorted by synced time.`);
        else if (sortType == 'date') this.$.toast.show(`${this.selectedPhotos.length} Photos sorted by date taken.`);
        else if (sortType == 'classification') this.$.toast.show(`${this.selectedPhotos.length} Photos sorted by photo classification.`);
      }
      this.shadowRoot.querySelector('#morePhotoOptions').close();
    });
  }

  getPhotoPriority(photoId, photos, sortType, photofirst_data) {
    if (sortType == 'name') {
      return '' + `${photos[photoId].filename || ''}`;
    } else if (sortType == 'sync') {
      return '' + `${photos[photoId].synced_time || 0}`;
    } else if (sortType == 'date') {
      return '' + `${photos[photoId].date_taken || 0}`;
    } else if (sortType == 'classification') {
      for (let key in photofirst_data) {
        // makes sure this is a photo chip
        if (key != '_editors' && !SquashNulls(this.inputModels[key], '_attributes', 'pixel_selection')) return '' + `${key || ''}`;
      }
    }
    return null;
  }
  /**
   * Returns the data for the item the photo is associated to (plus ids and connection
   * data in the case of a section)
   * @param {string} photoId - the id of the photo
   * @returns {Promise<object|null>}
   */
  async getItemDataForPhotoId(photoId) {
    if (!this.signedIn || !this.jobId || !photoId) return null;

    // Get the id of the associated item
    const associatedLocationsRef = FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/photos/${photoId}/associated_locations`);
    const associatedLocations = await associatedLocationsRef.once('value').then((s) => s.val());
    const mainItemId = Object.keys(associatedLocations || {})[0];
    if (!mainItemId) return null;
    // Build a default path, assuming the item is a node
    let mainItemPath = `nodes/${mainItemId}`;
    // Split the id to determine if it's a section
    const parts = mainItemId.split(':');
    const connId = parts[0];
    const sectionId = parts[1];
    // If the item has a section part, then update the path to be to the connection
    if (sectionId) {
      mainItemPath = `connections/${connId}`;
    }
    // Fetch the data for the main item
    let itemDataRef = FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/${mainItemPath}`);
    let itemData = await itemDataRef.once('value').then((s) => s.val());
    // If the item was a section, then save the connection data, pull out the section data, and apply ids and connection data
    if (sectionId) {
      let conn = JSON.parse(JSON.stringify(itemData));
      itemData = itemData.sections[sectionId];
      itemData.connId = connId;
      itemData.sectionId = sectionId;
      itemData.conn = conn;
      itemData.distanceRatios = this.calcDistanceRatios(itemData);
    } else {
      // Apply the node id
      itemData.nodeId = mainItemId;
    }
    return itemData;
  }

  setDisableManualPhotoResize() {
    if (this.view == 'trace' && this.enabledFeatures?.manual_photo_resize === true) {
      this.set('disableManualPhotoResize', false);
    } else this.set('disableManualPhotoResize', true);
  }

  setupManualPhotoResize() {
    // get all of the photo containers needed for the operation
    let mainPhotoContainer = this.shadowRoot.querySelector('.mainPhotoContainer');
    let sidePhotoContainers = this.shadowRoot.querySelectorAll('.sidePhotoContainer');
    // if we are not in trace view, remove all widths from main photo container and side photo containers
    if (this.view != 'trace') {
      // if we have a main photo container, delete its width
      if (mainPhotoContainer?.style) mainPhotoContainer.style.removeProperty('width');
      // loop through all of the side photo containers and delete their widths
      sidePhotoContainers.forEach((sidePhoto) => sidePhoto.style.removeProperty('width'));
      // remove the box-shadow property from the main photo and side photo containers if the feature flag is enabled
      if (this.enabledFeatures?.manual_photo_resize === true) {
        if (mainPhotoContainer?.style) mainPhotoContainer.style.removeProperty('box-shadow');
        sidePhotoContainers.forEach((sidePhoto) => sidePhoto.style.removeProperty('box-shadow'));
      }
    }
    // if trace view is on, set the widths to be 200px
    else {
      // if we have a main photo container, set its width to 200px so that we have a good reference point for resizing
      if (mainPhotoContainer) mainPhotoContainer.style.setProperty('width', '200px');
      // if we have side photo containers, set their widths to 200px
      sidePhotoContainers.forEach((sidePhoto) => sidePhoto.style.setProperty('width', '200px'));
      // add the box-shadow property to the main photo and side photo containers if the feature flag is enabled
      if (this.enabledFeatures?.manual_photo_resize === true) {
        if (mainPhotoContainer?.style) mainPhotoContainer.style.setProperty('box-shadow', 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px');
        sidePhotoContainers.forEach((sidePhoto) => sidePhoto.style.setProperty('box-shadow', 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'));
      }
    }
  }

  photoChanged(event) {
    this.updateHash();
    // Fetch the item data for the new photo id
    if (this.view != 'trace') {
      this.getItemDataForPhotoId(this.photo).then((itemData) => this.set('mainPhotoItem', itemData));
    }
    if (this.photo != null && this.filteredPhotoKeys.length && this.view == 'photos') {
      let index = this.filteredPhotoKeys.indexOf(this.photo);
      if (index != -1) {
        if (index > 0) {
          this.photoLeft = this.filteredPhotoKeys[index - 1];
        } else {
          this.photoLeft = null;
        }
        if (index < this.filteredPhotoKeys.length - 1) {
          this.photoRight = this.filteredPhotoKeys[index + 1];
        } else {
          this.photoRight = null;
        }
      } else {
        this.photoLeft = null;
        this.photoRight = null;
      }
      this.placeTaken = null;

      // Focus selected progress item.
      let progressItem = this.shadowRoot.querySelector(`#listItem${this.photo}`);
      let photoList = this.shadowRoot.querySelector('#photoList');
      if (progressItem && photoList) {
        // Position of progressItem (relative to left).
        let itemPos = progressItem.offsetLeft;
        let itemWidth = progressItem.offsetWidth;
        // Positions of visible photoList portion (relative to left).
        let visibleWidth = photoList.offsetWidth;
        let visibleLeftPos = photoList.scrollLeft;
        let visibleRightPos = visibleLeftPos + visibleWidth;
        // Overlfow of progressItem.
        let leftOverflow = visibleLeftPos - itemPos;
        let rightOverflow = itemPos - visibleRightPos + itemWidth;
        if (leftOverflow >= 0) {
          if (leftOverflow > itemWidth * 2) photoList.scrollTo({ left: itemPos - visibleWidth / 2 + itemWidth / 2, behavior: 'smooth' });
          else photoList.scrollLeft = itemPos;
        } else if (rightOverflow >= 0) {
          if (rightOverflow > itemWidth * 2) photoList.scrollTo({ left: itemPos - visibleWidth / 2 + itemWidth / 2, behavior: 'smooth' });
          else photoList.scrollLeft = itemPos - visibleWidth + itemWidth;
        }
      }
    }
    if (this.dontClearActiveData) {
      this.dontClearActiveData = false;
    } else if (event != 'pageLoad') {
      this.activeData = {
        key: null,
        itemKey: null,
        photoId: null
      };
    }
    // if the photo data changes, setup the photos for manual resize
    this.setupManualPhotoResize();
  }
  photosLoaded() {
    if (this.view == 'photos') {
      this.photosLoadedDebouncer = Debouncer.debounce(this.photosLoadedDebouncer, timeOut.after(100), () => {
        if (this.view == 'photos') {
          if (!this.photosAreLoaded) {
            this.photosAreLoaded = true;
            setTimeout(() => {
              this.updateAvatarParent = !this.updateAvatarParent;
            });
          }
          if (this.filteredPhotoKeys.length) {
            this.noPhotos = false;
            if ((!this.photo || !this.filteredPhotoKeys.includes(this.photo)) && this.view == 'photos') {
              this.photo = this.filteredPhotoKeys[0];
              this.$.toast.show('Switched to first photo.');
              this.photoChanged('pageLoad');
            }
          } else {
            this.noPhotos = true;
            this.photoLeft = null;
            this.photoRight = null;
          }
        }
      });
    }
  }
  inputModelGroupsLoaded() {
    if (this.inputModelGroups == null || this.inputModelGroups[this.inputModelGroup] == null) {
      var first;
      for (var groupName in this.inputModelGroups) {
        if (
          first == null ||
          (this.inputModelGroups[groupName]._priority != null &&
            (first._priority == null || this.inputModelGroups[groupName]._priority > first._priority))
        ) {
          first = {
            groupName,
            _priority: this.inputModelGroups[groupName]._priorty
          };
        }
      }
      if (first != null) {
        this.inputModelGroup = first.groupName;
      }
    }
  }
  imageLoaded() {
    // Redraw lines now that image is loaded and dimensions are correct
    var photoInputs = this.shadowRoot.querySelectorAll('photo-input');
    for (var i = 0; i < photoInputs.length; i++) {
      var line = photoInputs[i].shadowRoot.querySelector('katapult-photo-line');
      if (line != null && line.pointsChanged != null) {
        line.pointsChanged();
      }
    }
  }

  toggleAllowEmptyFields(event) {
    if (event.srcElement.tagName != 'PAPER-TOGGLE-BUTTON') {
      this.allowEmptyFields = !this.allowEmptyFields;
    }
  }
  setPicture(e) {
    var key = e.model.item;
    if (e.ctrlKey || e.metaKey) {
      if (this.selectedPhotos.indexOf(key) == -1) {
        this.push('selectedPhotos', key);
      } else {
        this.splice('selectedPhotos', this.selectedPhotos.indexOf(key), 1);
      }
    } else if (e.shiftKey) {
      var startIndex = this.filteredPhotoKeys.indexOf(this.photo);
      var endIndex = this.filteredPhotoKeys.indexOf(key);
      if (startIndex > endIndex) {
        var t = startIndex;
        startIndex = endIndex;
        endIndex = t;
      }
      for (let i = startIndex; i < endIndex + 1; i++) {
        if (this.selectedPhotos.indexOf(this.filteredPhotoKeys[i]) == -1) {
          this.push('selectedPhotos', this.filteredPhotoKeys[i]);
        }
      }
    } else {
      this.photo = key;
      this.$.mainPhoto.focus();
    }
  }
  getMainPhotoAssociation(view) {
    if (view == 'trace') return 'connection';
    if (view == 'cuEntry') return 'node';
    return null;
  }
  getPhotoAssociation(item) {
    return item?.isMidspan ? 'connection' : 'node';
  }
  showAnnotations(view, showLines, id) {
    return showLines && ['trace', 'transferHeights', 'pci'].includes(view);
  }
  setPictureLeftRight(e) {
    if (this.view == 'photos') {
      if (this.mode === 'hwDetail_DnGuy') {
        this.set('mode', null);
        this.$.photoControls.set('showDownGuyDetailToast', false);
      }
      let index = this.filteredPhotoKeys.indexOf(this.photo);
      if (e.currentTarget.id == 'photoLeft' || e.detail.key == 'left') {
        index--;
      } else if (e.currentTarget.id == 'photoRight' || e.detail.key == 'right') {
        index++;
      }
      if (index >= 0 && index < this.filteredPhotoKeys.length) {
        this.photo = this.filteredPhotoKeys[index];
      }
      if (this.$.photoLibrary.cancelClicked) {
        this.$.photoLibrary.cancelClicked();
      }
      this.$.mainPhoto.focus();
    }
  }
  stopPropagation(e) {
    e.stopPropagation();
  }
  addData(e) {
    this.$.photoControls.addData(e);
  }
  carryAttributes(e) {
    let photoId = e.detail.activeData.photoId,
      photo = this.$.photoControls.photoViewerLookup[photoId].photoData,
      property = e.detail.activeData.property,
      itemKey = e.detail.activeData.itemKey,
      data = photo.photofirst_data,
      item = SquashNulls(data, property, itemKey),
      traceId = item._trace || e.detail.traceId,
      cableDiameter = item.diameter || '',
      wireSpec = item.wire_spec;
    if (
      this.get(`traceListeners.traceData.${traceId}`) &&
      (cableDiameter == null || cableDiameter == '' || wireSpec == null || wireSpec == '') &&
      this.connectedPhotoList &&
      this.connectedPhotoList.connId == this.traceConnectionId &&
      this.connectedPhotoList.photos
    ) {
      let cable_type = this.get(`traceListeners.traceData.${traceId}.cable_type`),
        excludedCables = [
          'Primary',
          'Bundled Primary',
          'Secondary',
          'Neutral',
          'Open Secondary',
          'Power Drop',
          'Street Light Feed',
          'Power Guy',
          'Com Drop'
        ];
      if (cable_type) {
        let node1 = this.connection.node_id_1,
          node2 = this.connection.node_id_2,
          diameters = [],
          specs = [],
          kV = [],
          tension = [];

        // Also add the left and right photos to the photo list so we can check if
        // there is a wire spec listed on the pole that we should carry
        if (this.photoLeft) this.connectedPhotoList.photos.unshift(`photos/${this.photoLeft}/photofirst_data`);
        if (this.photoRight) this.connectedPhotoList.photos.unshift(`photos/${this.photoRight}/photofirst_data`);
        GetJobData(this.jobId, this.connectedPhotoList.photos).then((data) => {
          for (var path in data) {
            var pfData = data[path];
            if (pfData) {
              let markers = DataViews.help.getMarkers(pfData, this.get(`traceListeners.traceData`), {
                includeAllMarkerTypes: true,
                allowProposed: true
              });
              let matchingMarker = markers.find((x) => x._trace == traceId);
              if (matchingMarker) {
                if (matchingMarker.diameter != '' && matchingMarker.diameter != null) diameters.push(matchingMarker.diameter);
                if (matchingMarker.wire_spec != '' && matchingMarker.wire_spec != null) specs.push(matchingMarker.wire_spec);
                if (matchingMarker.kV != '' && matchingMarker.kV != null) kV.push(matchingMarker.kV);
                if (matchingMarker.tension != '' && matchingMarker.tension != null) tension.push(matchingMarker.tension);
              }
            }
          }
          diameters.sort((a, b) => a - b);
          let update = {};
          if (diameters.length > 0 && !excludedCables.includes(cable_type) && Number(cableDiameter) <= 0)
            update['photos/' + photoId + '/photofirst_data/' + property + '/' + itemKey + '/diameter/'] = diameters[0];
          if (
            specs.length > 0 &&
            ((wireSpec == null && this.tier == 'katapult pro') ||
              wireSpec == '' ||
              SquashNulls(this.modelConfig, 'insert_wire_spec_while_measure') === true)
          )
            update['photos/' + photoId + '/photofirst_data/' + property + '/' + itemKey + '/wire_spec/'] = specs[0] || '';
          if (kV.length > 0 && (item.kV == null || item.kV == ''))
            update['photos/' + photoId + '/photofirst_data/' + property + '/' + itemKey + '/kV/'] = kV[0] || '';
          if (tension.length > 0 && (item.tension == null || item.tension == ''))
            update['photos/' + photoId + '/photofirst_data/' + property + '/' + itemKey + '/tension/'] = tension[0] || '';
          if (Object.keys(update).length > 0)
            FirebaseWorker.ref('/photoheight/jobs/' + this.jobId).update(update, (e) => {
              if (e) console.log('error', e);
            });
        });
      }
    }
  }
  photoLibraryAdd(e) {
    this.$.photoLibrary.tapPhotoToAdd(e);
  }
  markConnectionTracingComplete(e) {
    if (!this.traceSections) return;
    // Make an array to store the photo keys
    var photos = [];
    // If the main section photo exists, add it to the photos list
    if (this.photo != null && this.photo != '') {
      photos.push(this.photo);
    }
    // Add any photos from traceSections
    for (var i = 0; i < this.traceSections.length; i++) {
      photos.push(this.traceSections[i].mainPhoto);
    }

    window.setTimeout(() => {
      // Flag for if tracing is complete on the connection
      var tracingComplete = false;
      // The number of section photos
      var photoCount = photos.length;
      // Stores the photofirst_data of each section photo
      var photoData = {};
      // 2D array to store all the traces for each section photo
      var photoTraces = [];
      // Counts the number of traces found
      var traceCount = 0;
      // Loop through all the section photos and get their photofirst data
      for (let i = 0; i < photos.length; i++) {
        FirebaseWorker.ref('/photoheight/jobs/' + this.jobId + '/photos/' + photos[i] + '/photofirst_data').once('value', (snapshot) => {
          var data = snapshot.val();
          // Store the data for the photo key in photoData
          photoData[photos[i]] = data;
          // If we have all the photo data, process it
          if (--photoCount == 0) {
            // Loop through each section photo
            for (var sectionKey in photoData) {
              // Create a temp array for the traces on the current section photo
              var tempTraces = [];
              // Loop through each property (the marker type) in the section's photofirst_data
              for (var property in photoData[sectionKey]) {
                // Check if the property doesn't start with '_' and has a _trace_type in the models
                if (property[0] != '_' && SquashNulls(this.inputModels, property, '_trace_type') != '') {
                  // Loop through each item for the property
                  for (var itemKey in photoData[sectionKey][property]) {
                    // If the item has a trace, add it to photoTraces
                    if (photoData[sectionKey][property][itemKey]._trace) {
                      // Add the trace key to tempTraces
                      tempTraces.push(photoData[sectionKey][property][itemKey]._trace);
                      traceCount++;
                    }
                  }
                }
              }
              // Add the array of traces to the photoTraces array
              photoTraces.push(tempTraces);
            }

            // If there were some traces, initially mark tracingComplete as true
            if (traceCount > 0) tracingComplete = true;

            // Loop throught the photo traces arrays
            for (var j = 0; j < photoTraces.length; j++) {
              // If the current array of traces doesn't equal the next one, then tracing is not complete
              if (j + 1 < photoTraces.length && CompareArrays(photoTraces[j], photoTraces[j + 1]) == false) {
                tracingComplete = false;
                break;
              }
            }

            // Update the connection
            FirebaseWorker.ref(
              '/photoheight/jobs/' + this.jobId + '/connections/' + this.traceConnectionId + '/attributes/tracing_complete/auto'
            ).set(tracingComplete);
          }
        });
      }
    }, 100);
  }
  togglePhotoChooser(e) {
    this.$.photoLibrary.togglePhotoChooser(e.detail.open, e.detail.property, e.detail.sourceElement);
  }
  showDone() {
    this.$.toast.show('Photos Associated. Check to make sure the are associated accurately!!');
  }
  showError(e) {
    if (e.detail.photoId != null) {
      this.photo = e.detail.photoId;
    }
    this.$.toast.show(e.detail.message);
  }
  isPhotoDone(photoFirstData) {
    if (photoFirstData == null || (Object.keys(photoFirstData).length == 1 && photoFirstData._editors != null)) {
      return false;
    } else {
      return true;
    }
  }
  addPhotoToLibrary(e) {
    this.$.photoLibrary.openAddPhotoDialog();
  }
  reversePhotoOrder(e, d) {
    let tempId = structuredClone(this.photoLeft);
    this.photoLeft = structuredClone(this.photoRight);
    this.photoRight = tempId;
    tempId = structuredClone(this.leftNode);
    this.set('leftNode', structuredClone(this.rightNode));
    this.set('rightNode', tempId);

    if (this.traceSections && this.traceSections.length > 0) {
      let newArray = [this.mainPhotoItem];
      newArray = newArray.concat(this.traceSections);
      let l = newArray.length,
        limit = Math.floor(l / 2);
      for (let i = 0; i < limit; i = i + 2) {
        let t = newArray[i];
        newArray[i] = newArray[l - (1 + i)];
        newArray[l - (1 + i)] = t;
      }
      this.set('mainPhotoItem', newArray.shift());
      this.photo = GetMainPhoto(this.mainPhotoItem.photos);
      this.set('traceSections', newArray);
    }

    this.$.toast.show('Swapped order of photos horizontally');
  }
  openInMaps(e) {
    let associated_locations = e.currentTarget.parentElement.get('photoData.associated_locations');
    if (associated_locations == null) {
      this.$.toast.show('This photo is not associated to any nodes');
    } else {
      var associatedLocationList = [];
      for (var key in associated_locations) {
        associatedLocationList.push({
          key: key,
          type: associated_locations[key]
        });
      }
      if (associatedLocationList.length > 1) {
        this.associatedLocationList = associatedLocationList;
      } else {
        this.zoomMapToLocation(associatedLocationList[0]);
      }
    }
  }
  selectZoomLocation(e) {
    this.zoomMapToLocation(e.currentTarget.templateInstance.model.location, e.type == 'dblclick');
    this.associatedLocationList = null;
  }
  zoomMapToLocation(object, open) {
    if ((!this.linked && window.opener == null) || open) {
      var a = document.createElement('a');
      a.href = encodeURI(window.location.pathname.replace('/photos/', '/map/') + '#{"job_id":"' + this.jobId + '", "linked":true}');
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      this.linked = true;
    }
    FirebaseWorker.ref('/photoheight/company_space/' + this.userGroup + '/user_data/' + this.get('user.uid') + '/zoom_map/').set(object);
  }
  selectText(e) {
    if (e.currentTarget.select) {
      e.currentTarget.select();
    } else {
      dom(e.currentTarget.shadowRoot).querySelector('#input').select();
    }
  }
  parseQueryString(string) {
    var urlSplit = string.split('?');
    var vars = urlSplit[urlSplit.length - 1].split('&');
    var json = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      json[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return json;
  }
  sortedByShortcut(photofirst_data, inputModelGroups, inputModelGroup) {
    if (photofirst_data == null || inputModelGroups == null) {
      return null;
    }
    var inputModel = inputModelGroups[inputModelGroup];
    var keys = Object.keys(photofirst_data);
    return keys.sort(function (a, b) {
      return ((inputModel[b] || { priority: 0 }).priority || 0) - ((inputModel[a] || { priority: 0 }).priority || 0);
    });
  }
  getOverflow(view, photos) {
    this.photoListClassesDebouncer = Debouncer.debounce(this.photoListClassesDebouncer, timeOut.after(100), () => {
      var photoListClasses = '';
      var photoList = this.shadowRoot.querySelector('#photoList');
      if (photoList != null) {
        var photoCount = this.filteredPhotoKeys.length;
        var photoCountWidth = photoCount * 5;
        var displayWidth = photoList.clientWidth;
        if (photoCountWidth > displayWidth) {
          photoListClasses += 'hasScrollBar';
        }
        if (view == 'upshot') {
          photoListClasses += 'upshot';
        }
      }
      this.photoListClasses = photoListClasses;
    });
  }
  getProgressItemStyle(photoId, currentPhoto, showPossibleSyncPhotos, associatedPhotos) {
    var style = '';
    if (!this.showPossibleSyncPhotos) {
      let summary = this.get(`photoSummary.${photoId}`) || {};
      if (associatedPhotos?.[photoId]) {
        style += ' border-top: 9px solid var(--paper-cyan-500);';
      } else if (summary.associated) {
        style += ' border-top: 9px solid var(--paper-light-green-800);';
        if (this.photosToHighlight.includes(photoId)) style += ' border-top: 9px solid var(--paper-red-700);';
      }
      if (photoId == currentPhoto) {
        style += ' background-color: var(--paper-red-500); border-color: var(--paper-red-800);';
      } else if (summary.status == 'upload_started' || summary.status == 'upload_error') {
        style += ' background-color: var(--paper-grey-800)';
      } else if (summary.status == 'upload_active') {
        style += ' background-color: var(--paper-grey-500)';
      } else if (summary.sync) {
        style += ' background-color: var(--paper-blue-500); border-color: var(--paper-blue-800);';
      } else if (summary.job) {
        style += ' background-color: var(--paper-purple-500); border-color: var(--paper-purple-800);';
      } else if (summary.cable_tag) {
        style += ' background-color: var(--paper-amber-500); border-color: var(--paper-amber-900);';
      } else if (summary.data) {
        style += ' background-color: var(--paper-light-green-500);';
      }
      if (this.photosToHighlight.includes(photoId)) style += ' border-top: 9px solid var(--paper-red-700);';
    } else {
      if (photoId == currentPhoto) {
        style += ' background-color: var(--paper-red-500);';
      } else {
        style += this.photoStyle[photoId];
      }
    }
    if (this.selectedPhotos.indexOf(photoId) != -1) {
      style += ' background-color:yellow;';
    }
    return style;
  }
  findSyncPhotos(e) {
    if (!this.showPossibleSyncPhotos) {
      var previousPhotoDate_taken = new Date(this.get(`photoSummary.${this.filteredPhotoKeys[0]}.date_taken`) * 1000);
      var previousPhotoHours = previousPhotoDate_taken.getHours();
      var previousPhotoMinutes = previousPhotoDate_taken.getMinutes();
      var previousPhotoTime = previousPhotoHours * 60 + previousPhotoMinutes;
      this.photoStyle = {};
      this.photoStyle[this.filteredPhotoKeys[0]] = ' background-color:#ff8300;';
      for (let i = 1; i < this.filteredPhotoKeys.length; i++) {
        var currentPhotoDate_taken = new Date(this.get(`photoSummary.${this.filteredPhotoKeys[i]}.date_taken`) * 1000);
        var currentPhotoHours = currentPhotoDate_taken.getHours();
        var currentPhotoMinutes = currentPhotoDate_taken.getMinutes();
        var currentPhotoTime = currentPhotoHours * 60 + currentPhotoMinutes;
        if (currentPhotoTime - previousPhotoTime > 5) {
          this.photoStyle[this.filteredPhotoKeys[i]] = ' background-color:#ff8300;';
        } else {
          this.photoStyle[this.filteredPhotoKeys[i]] = ' background-color:white;';
        }
        var previousPhotoDate_taken = currentPhotoDate_taken;
        var previousPhotoHours = currentPhotoHours;
        var previousPhotoMinutes = currentPhotoMinutes;
        var previousPhotoTime = currentPhotoTime;
      }
      this.showPossibleSyncPhotos = true;
    } else {
      this.showPossibleSyncPhotos = false;
    }
  }
  calibrateCamera(e) {
    if (this.userGroup == 'katapult') {
      e.detail.keyboardEvent.preventDefault();
      this.calibratingCamera = !this.calibratingCamera;
      if (this.calibratingCamera) {
        HEIGHT_FORMAT_OVRERIDE = 'decimal-feet-inches';
      } else {
        HEIGHT_FORMAT_OVRERIDE = undefined;
      }
      // Toggle use metric units so heights are recalced
      this.set('userData.use_metric_units', !this.userData.use_metric_units);
      this.set('userData.use_metric_units', !this.userData.use_metric_units);

      // Toggle use decimal feet so heights are recalced
      this.set('userData.use_decimal_feet', !this.userData.use_decimal_feet);
      this.set('userData.use_decimal_feet', !this.userData.use_decimal_feet);
    }
  }
  resetCalibrationValues(e) {
    this.aMin = 0;
    this.aMax = 0;
    this.aIncr = 0.001;
    this.bMin = 0;
    this.bMax = 0;
    this.bIncr = 0.01;
    this.cMin = -0.1;
    this.cMax = 0;
    this.cIncr = 0.01;
  }
  loopCalibration(e) {
    this.aMin = parseFloat(this.aMin);
    this.aMax = parseFloat(this.aMax);
    this.aIncr = parseFloat(this.aIncr);
    this.bMin = parseFloat(this.bMin);
    this.bMax = parseFloat(this.bMax);
    this.bIncr = parseFloat(this.bIncr);
    this.cMin = parseFloat(this.cMin);
    this.cMax = parseFloat(this.cMax);
    this.cIncr = parseFloat(this.cIncr);
    if (this.aMax < this.aMin || this.bMax < this.bMin || this.cMax < this.cMin) {
      this.$.toast.show('Error: Please fix your ranges');
    } else if (this.aIncr <= 0 || this.bIncr <= 0 || this.cIncr <= 0) {
      this.$.toast.show('Error: Please fix your increment values');
    } else {
      FirebaseWorker.ref('/photoheight/jobs/' + this.jobId + '/photos/').once(
        'value',
        function (snapshot) {
          var photos = snapshot.val();
          if (photos != null) {
            var output = {};
            var focalLengths = [];
            // build array of focal lengths
            for (let key in photos) {
              var focal_length = photos[key].focal_length;
              let focalLengthNotFound = true;
              for (let i = 0; i < focalLengths.length; i++) {
                if (focal_length == focalLengths[i]) {
                  focalLengthNotFound = false;
                  break;
                }
              }
              if (focalLengthNotFound) {
                output[focal_length] = {};
                focalLengths.push(focal_length);
              }
            }
            focalLengths.sort(function (a, b) {
              return a - b;
            });
            // build output object grouping each photo by focal length
            for (let i = 0; i < focalLengths.length; i++) {
              for (let key in photos) {
                if (photos[key].focal_length == focalLengths[i]) {
                  var heightImage = photos[key];
                  var fileName = heightImage.filename;
                  // multiply min, max, and incr values by 10e5 to avoid float point errors
                  var aMin = this.aMin * 10e5,
                    aMax = this.aMax * 10e5,
                    aIncr = this.aIncr * 10e5,
                    bMin = this.bMin * 10e5,
                    bMax = this.bMax * 10e5,
                    bIncr = this.bIncr * 10e5,
                    cMin = this.cMin * 10e5,
                    cMax = this.cMax * 10e5,
                    cIncr = this.cIncr * 10e5;
                  output[focalLengths[i]][fileName] = {
                    time: new Date(),
                    image: heightImage.filename,
                    iterations: []
                  };
                  var count = 1;
                  while (aMin <= aMax) {
                    while (bMin <= bMax) {
                      while (cMin <= cMax) {
                        var w = heightImage.image_width;
                        var h = heightImage.image_height;
                        if (heightImage.rotation == 1 || heightImage.rotation == 3) {
                          var t = w;
                          w = h;
                          h = t;
                        }
                        var heights = [],
                          anchors = [],
                          anchor_calibration = SquashNulls(heightImage, 'photofirst_data', 'anchor_calibration'),
                          known_points = heightImage?.photofirst_data?.known_point ?? heightImage?.photofirst_data?.height_marker,
                          distortionValues = {};
                        if (anchor_calibration != '' && known_points != '') {
                          // add calibration points to anchors for calibation
                          for (let anchor in anchor_calibration) {
                            anchors.push({
                              height: ParseHeight(anchor_calibration[anchor].height).decimalFeet,
                              x: (anchor_calibration[anchor].pixel_selection[0].percentX / 100) * w,
                              y: (anchor_calibration[anchor].pixel_selection[0].percentY / 100) * h
                            });
                          }
                          // add known_points to anchors for calibration
                          if (!this.stickHeightsOnly) {
                            for (let point in known_points) {
                              anchors.push({
                                height: ParseHeight(known_points[point].known_height ?? known_points[point].label).decimalFeet,
                                x: (known_points[point].pixel_selection[0].percentX / 100) * w,
                                y: (known_points[point].pixel_selection[0].percentY / 100) * h
                              });
                            }
                          }
                          var focalLength = heightImage.focal_length;
                          var cameraModel = heightImage.camera_model;
                          // convert back to true values for stickAlign
                          distortionValues = {
                            aMin: aMin / 10e5,
                            bMin: bMin / 10e5,
                            cMin: cMin / 10e5
                          };
                          // doing math now :)
                          var stickAlign = calibratePhoto.singleAlign(anchors, w, h, focalLength, cameraModel, distortionValues, 'Min');
                          for (let i = 0; i < anchors.length; i++) {
                            heights.push({
                              calculated: calibratePhoto.getFeet(anchors[i].x, anchors[i].y, stickAlign),
                              known: anchors[i].height
                            });
                          }
                          // If we didn't include the known heights in teh calibration anchors, add them to the heights for error checking
                          if (this.stickHeightsOnly) {
                            for (let point in known_points) {
                              const height = parseFloat(known_points[point].known_height ?? known_points[point].label);
                              const x = (known_points[point].pixel_selection[0].percentX / 100) * w;
                              const y = (known_points[point].pixel_selection[0].percentY / 100) * h;
                              heights.push({ calculated: calibratePhoto.getFeet(x, y, stickAlign), known: height });
                            }
                          }
                          heights.sort(function (a, b) {
                            return a.known - b.known;
                          });
                          if (distortionValues.aMin != null && distortionValues.bMin != null && distortionValues.cMin != null) {
                            output[focalLengths[i]][fileName].iterations.push({
                              heights: heights,
                              a: distortionValues.aMin.toFixed(5),
                              b: distortionValues.bMin.toFixed(5),
                              c: distortionValues.cMin.toFixed(5)
                            });
                          }
                        } else {
                          console.warn(fileName + ' is not calibrated');
                          delete output[focalLengths[i]][fileName];
                        }
                        cMin += cIncr;
                        count++;
                      }
                      cMin = this.cMin * 10e5;
                      bMin += bIncr;
                    }
                    cMin = this.cMin * 10e5;
                    bMin = this.bMin * 10e5;
                    aMin += aIncr;
                  }
                }
              }
            }
          }
          this.estimateDistortionValues(output);
        }.bind(this)
      );
    }
  }
  estimateDistortionValues(json) {
    this.set('focalLengthsToTest', []);
    for (let focal_length in json) {
      var aD_string = 'aD = ',
        bD_string = 'bD = ',
        cD_string = 'cD = ',
        aD_value = 0,
        bD_value = 0,
        cD_value = 0,
        lowest_score = 100000,
        lowest_score_iteration = 0,
        score = 0,
        highest_score = 0,
        reference = [0, 2.5, 6.5, 10.5, 14.5, 16.5, 25, 30, 35, 40, 50, 60, 70],
        num_iterations = 0,
        count = 0;
      for (let photo in json[focal_length]) {
        num_iterations = json[focal_length][photo].iterations.length;
        break;
      }
      // skip to next focal_length if no photos exist
      if (num_iterations == 0) continue;
      // outer loop on abc iterations
      for (let i = 0; i < num_iterations; i++) {
        // inner loop on each photo in json
        let worstMarkerErrorFromPhotos = 0;
        let photoCount = 0;
        for (let photo in json[focal_length]) {
          // score each height
          let worstMarkerForPhoto = null;
          for (let h = 0; h < json[focal_length][photo].iterations[i].heights.length; h++) {
            const calculated = json[focal_length][photo].iterations[i].heights[h].calculated;
            const known = json[focal_length][photo].iterations[i].heights[h].known;
            let heightsToUse =
              this.heightsToUse
                ?.split(',')
                .map((x) => x.trim())
                .filter((x) => x)
                .map((x) => Number(x)) ?? [];
            if (heightsToUse.length && !heightsToUse.includes(known)) {
              continue;
            }
            // score is difference in inches
            score = Math.abs(calculated - known) * 12;
            if (score > highest_score) {
              highest_score = score;
            }
            if (worstMarkerForPhoto == null || score > worstMarkerForPhoto.score) {
              worstMarkerForPhoto = { score, known };
            }
          }
          if (worstMarkerForPhoto?.score) {
            worstMarkerErrorFromPhotos += worstMarkerForPhoto.score;
            photoCount++;
          }
          console.log('worstMarkerForPhoto', worstMarkerForPhoto, focal_length, i, photo);
        }
        if (this.useAveragePhotoError) {
          const averageError = worstMarkerErrorFromPhotos / photoCount;
          if (averageError < lowest_score && photoCount > 0) {
            lowest_score = averageError;
            lowest_score_iteration = count;
          }
        } else {
          // track abc iteration with best, worst score
          if (highest_score < lowest_score && highest_score > 0) {
            lowest_score = highest_score;
            lowest_score_iteration = count;
          }
        }
        score = 0;
        highest_score = 0;
        count++;
      }
      console.log('best iteration', lowest_score_iteration);
      for (let photo in json[focal_length]) {
        aD_string += json[focal_length][photo].iterations[lowest_score_iteration].a + ' ';
        bD_string += json[focal_length][photo].iterations[lowest_score_iteration].b + ' ';
        cD_string += json[focal_length][photo].iterations[lowest_score_iteration].c + ' ';
        if (aD_value == 0) aD_value = json[focal_length][photo].iterations[lowest_score_iteration].a;
        if (bD_value == 0) bD_value = json[focal_length][photo].iterations[lowest_score_iteration].b;
        if (cD_value == 0) cD_value = json[focal_length][photo].iterations[lowest_score_iteration].c;
      }
      this.calibrationResults[focal_length] = {
        aD_string: aD_string,
        bD_string: bD_string,
        cD_string: cD_string,
        aD_value: Number(aD_value),
        bD_value: Number(bD_value),
        cD_value: Number(cD_value),
        lowest_score: lowest_score,
        lowest_score_iteration: lowest_score_iteration
      };
      if (this.calibrationResults != null && this.calibrationResults[focal_length] != null) {
        this.testCameraModel[focal_length] = {
          aMin: this.calibrationResults[focal_length].aD_value,
          aMid: this.calibrationResults[focal_length].aD_value,
          aMax: this.calibrationResults[focal_length].aD_value,
          bMin: this.calibrationResults[focal_length].bD_value,
          bMid: this.calibrationResults[focal_length].bD_value,
          bMax: this.calibrationResults[focal_length].bD_value,
          cMin: this.calibrationResults[focal_length].cD_value,
          cMid: this.calibrationResults[focal_length].cD_value,
          cMax: this.calibrationResults[focal_length].cD_value
        };
      }
    }
    for (let focal_length in this.testCameraModel) {
      this.push('focalLengthsToTest', focal_length);
    }
    this.$.cameraCalibrationDialog.open();
  }
  tryNewDistortionValues() {
    this.$.toast.show('Updating stick align...');
    var focalLengthsToTest = [];
    for (let i = 0; i < this.$.cameraCalibrationDialog.querySelectorAll('paper-checkbox').length; i++) {
      var id = this.$.cameraCalibrationDialog.querySelectorAll('paper-checkbox')[i].id;
      var checked = this.$.cameraCalibrationDialog.querySelectorAll('paper-checkbox')[i].checked;
      if (checked) focalLengthsToTest.push(Number(id));
    }
    if (focalLengthsToTest.length > 0) {
      if (this.aMin != this.aMax) {
        let aD_value = this.calibrationResults[focalLengthsToTest[0]].aD_value;
        this.aIncr /= 5;
        this.aMax = (aD_value * 10e5 + this.aIncr * 2 * 10e5) / 10e5;
        this.aMin = (aD_value * 10e5 - this.aIncr * 2 * 10e5) / 10e5;
      }
      if (this.bMin != this.bMax) {
        let bD_value = this.calibrationResults[focalLengthsToTest[0]].bD_value;
        this.bIncr /= 5;
        this.bMax = (bD_value * 10e5 + this.bIncr * 2 * 10e5) / 10e5;
        this.bMin = (bD_value * 10e5 - this.bIncr * 2 * 10e5) / 10e5;
      }
      if (this.cMin != this.cMax) {
        let cD_value = this.calibrationResults[focalLengthsToTest[0]].cD_value;
        this.cIncr /= 5;
        this.cMax = (cD_value * 10e5 + this.cIncr * 2 * 10e5) / 10e5;
        this.cMin = (cD_value * 10e5 - this.cIncr * 2 * 10e5) / 10e5;
      }
    }
    FirebaseWorker.ref('/photoheight/jobs/' + this.jobId + '/photos/').once(
      'value',
      function (focalLengthsToTest, snapshot) {
        var photos = snapshot.val();
        if (photos != null) {
          for (let photoId in photos) {
            var photo = photos[photoId];
            var focal_length = photo.focal_length;
            var photofirst_data = SquashNulls(photo, 'photofirst_data');
            if (photofirst_data != '' && focalLengthsToTest.indexOf(focal_length) > -1) {
              var anchors = SquashNulls(photo, 'photofirst_data', 'anchor_calibration');
              if (!anchors) continue;
              this.$.photoControls.runStickAlign(anchors, photo, photoId, 'new', this.testCameraModel);
            }
          }
        }
        this.$.toast.show('Stick aligns updated.');
        this.set('focalLengthsToTest', []);
        this.set('testCameraModel', []);
        this.set('calibrationResults', {});
      }.bind(this, focalLengthsToTest)
    );
  }
  async calcStickAlignUsingSetValues(userGroup, photoId, useSetValues, aSet, bSet, cSet) {
    if (useSetValues && userGroup == 'katapult' && photoId) {
      const photo =
        this.$.mainPhoto.photoData ??
        (await FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/photos/${photoId}`)
          .once('value')
          .then((s) => s.val()));
      const cameraModel = {
        [photo.focal_length]: {
          aMin: aSet,
          aMid: aSet,
          aMax: aSet,
          bMin: bSet,
          bMid: bSet,
          bMax: bSet,
          cMin: cSet,
          cMid: cSet,
          cMax: cSet
        }
      };
      this.$.photoControls.runStickAlign(photo?.photofirst_data?.anchor_calibration, photo, photoId, 'new', cameraModel);
    }
  }
  closeCameraCalibrationDialog() {
    this.$.cameraCalibrationDialog.close();
    this.set('focalLengthsToTest', []);
    this.set('testCameraModel', []);
    this.set('calibrationResults', {});
  }
  _computeOpened(associatedLocationList) {
    return associatedLocationList != null;
  }
  getDrawingClass(mode, view, isMain) {
    if (mode != null && mode.substr(0, 4) == 'draw' && (view == 'trace' || isMain)) {
      // if user's OS is not windows, use 'chromeDrawing' class (custom crosshair cursor) because Chrome OS crosshair is not good for photo calibration
      if (navigator.userAgent.indexOf('Win') == -1) {
        return 'chromeDrawing';
      }
      // if user's OS is windows, use original 'drawing' class (standard crosshair cursor)
      return 'drawing';
    }
  }
  getSummaryAttr(photoId, attr) {
    return this.get(`photoSummary.${photoId}.${attr}`);
  }
  displayToastMessage(e) {
    this.$.toast.show(e.detail.message || e.detail);
  }
  getSelectedPhotoLabel() {
    return this.selectedPhotos.length + ' photo' + (this.selectedPhotos.length == 1 ? '' : 's');
  }
  photoListDragStart(e) {
    var firebaseKey = SquashNulls(e, 'model', 'item');
    if (firebaseKey && this.selectedPhotos.indexOf(firebaseKey) == -1) {
      this.selectedPhotos.push(firebaseKey);
    }
    dom(this.$.dragImage).innerText = this.getSelectedPhotoLabel();
    e.dataTransfer.setDragImage(this.$.dragImage, -10, -10);
    e.dataTransfer.setData(
      'application/json',
      JSON.stringify({
        photos: this.selectedPhotos,
        jobid: this.jobId,
        move_from_associated: true
      })
    );
    e.dataTransfer.effectAllowed = 'move';
  }
  deslecteAllPhotos() {
    this.selectedPhotos = [];
  }
  deletePhotos() {
    this.$.photoControls.confirm(
      'Delete Photos From Job',
      'Are you sure you want to delete these photos from this job?',
      'Delete',
      'Cancel',
      'background-color:var(--paper-red-500); color:white',
      null,
      async () => {
        let jobRef = FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`);
        let jobUpdate = {};
        let countersUpdate = {};
        let promises = this.selectedPhotos.map(async (photoId) => {
          // Create update removing photo from /photos and /photo_summary.
          jobUpdate[`photos/${photoId}`] = null;
          jobUpdate[`photo_summary/${photoId}`] = null;
          // Also fetch associated locations...
          let associatedLocations = await jobRef
            .child(`photos/${photoId}/associated_locations`)
            .once('value')
            .then((s) => s.val());
          //... and remove photo from those locations.
          for (let key in associatedLocations) {
            if (associatedLocations[key] === 'node') {
              jobUpdate[`nodes/${key}/photos/${photoId}`] = null;
            } else if (associatedLocations[key] === 'section') {
              let parts = key.split(':');
              jobUpdate[`connections/${parts[0]}/sections/${parts[1]}/photos/${photoId}`] = null;
            }
          }
          // fetch the photo summary
          let photoSummary = await jobRef
            .child(`photo_summary/${photoId}`)
            .once('value')
            .then((s) => s.val());
          // Remove photo from firebase database.
          ///
          // WARNING: Job photos are by reference, meaning if you delete a photo from a copy of a job it will also delete the photo that the original job points to.
          //          That is why this code is commented out.
          ///
          // // Delete various photo sizes from firebase storage.
          // for (let size of ['full.jpg', 'full.webp', 'extra_large.webp', 'large.webp', 'small.webp', 'tiny.webp']) {
          //   await firebase.storage().ref(`photos/${photoId}_${size}`).delete().catch(e => console.log(e));
          // }

          let photo = await jobRef
            .child(`photos/${photoId}`)
            .once('value')
            .then((s) => s.val());
          // decrease the photo_folder counters
          if (photo.folder_id) {
            let folder = await jobRef
              .child(`photo_folders/${photo.folder_id}`)
              .once('value')
              .then((s) => s.val());
            if (folder) {
              if (folder.numPhotos && folder.numPhotos > 0) {
                jobUpdate[`photo_folders/${photo.folder_id}/numPhotos`] = folder.numPhotos - 1;
              }
              if (folder.numUploaded && folder.numUploaded > 0 && !photoSummary.status) {
                jobUpdate[`photo_folders/${photo.folder_id}/numUploaded`] = folder.numUploaded - 1;
              }
              if (photoSummary.data && folder.numTagged && folder.numTagged > 0) {
                jobUpdate[`photo_folders/${photo.folder_id}/numTagged`] = folder.numTagged - 1;
              }
              if (photoSummary.associated && folder.numAssociated && folder.numAssociated > 0) {
                jobUpdate[`photo_folders/${photo.folder_id}/numAssociated`] = folder.numAssociated - 1;
              }
            }
          }
          // decrease the counters for the entire job
          let counters = await FirebaseWorker.ref(`photoheight/counters/${this.userGroup}/${this.jobId}`)
            .once('value')
            .then((s) => s.val());
          if (counters.numPhotos && counters.numPhotos.value > 0) {
            countersUpdate['numPhotos'] = { value: counters.numPhotos.value - 1, last_modified: Date.now() };
          }
          if (counters.numUploaded && counters.numUploaded.value > 0 && !photoSummary.status) {
            countersUpdate['numUploaded'] = { value: counters.numUploaded.value - 1, last_modified: Date.now() };
          }
          if (photoSummary.data && counters.numTagged && counters.numTagged.value > 0) {
            countersUpdate['numTagged'] = { value: counters.numTagged.value - 1, last_modified: Date.now() };
          }
          if (photoSummary.associated && counters.numAssociated && counters.numAssociated.value > 0) {
            countersUpdate['numAssociated'] = { value: counters.numAssociated.value - 1, last_modified: Date.now() };
          }
        });
        await Promise.all(promises);
        this.selectedPhotos = [];
        await jobRef.update(jobUpdate);
        await FirebaseWorker.ref(`photoheight/counters/${this.userGroup}/${this.jobId}`).update(countersUpdate);
        this.$.toast.show('Photos Deleted.');
      }
    );
  }
  unassociatePhotos() {
    this.$.photoControls.confirm(
      'Unassociate Photos',
      'Are you sure you want Unassociate these photos from all nodes and sections?',
      'Unassociate',
      'Cancel',
      'background-color:var(--secondary-color); color:white',
      null,
      async () => {
        let jobRef = FirebaseWorker.ref(`photoheight/jobs/${this.jobId}`);
        let update = {};
        let promises = this.selectedPhotos.map(async (photoId) => {
          // Create update removing photo from /photos and /photo_summary.
          update[`photos/${photoId}/associated_locations`] = null;
          update[`photo_summary/${photoId}/associated`] = null;
          // Also fetch associated locations...
          let associatedLocations = await jobRef
            .child(`photos/${photoId}/associated_locations`)
            .once('value')
            .then((s) => s.val());
          //... and remove photo from those locations.
          for (let key in associatedLocations) {
            if (associatedLocations[key] === 'node') {
              update[`nodes/${key}/photos/${photoId}`] = null;
            } else if (associatedLocations[key] === 'section') {
              let parts = key.split(':');
              update[`connections/${parts[0]}/sections/${parts[1]}/photos/${photoId}`] = null;
            }
          }
        });
        await Promise.all(promises);
        this.selectedPhotos = [];
        await jobRef.update(update);
        this.$.toast.show('Photos Unassociated.');
      }
    );
  }
  async associatePhotos() {
    // get photo data from the job
    let photos = await GetJobData(this.jobId, 'photos').then((data) => data.photos || null);
    let photosToAssociate = {};
    let update = {};

    // flag to identify that a sync photo exists in the users selected photos
    let foundSyncPhoto;
    // build proper photos object to pass into the association code
    for (let i = 0; i < this.selectedPhotos.length; i++) {
      photosToAssociate[this.selectedPhotos[i]] = photos[this.selectedPhotos[i]];
      if (photos[this.selectedPhotos[i]]?.photofirst_data?.sync) foundSyncPhoto = true;
    }

    // if the user has included a sync photo in their selection, allow them to associate
    if (foundSyncPhoto) {
      this.$.photoControls.confirm(
        'Associate Photos',
        `Are you sure you want associate ${this.selectedPhotos.length} photos?`,
        'Associate',
        'Cancel',
        'background-color:var(--secondary-color); color:white',
        null,
        async () => {
          let nodes = await FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/nodes`)
            .once('value')
            .then((s) => s.val());
          let connections = await FirebaseWorker.ref(`photoheight/jobs/${this.jobId}/connections`)
            .once('value')
            .then((s) => s.val());

          this.$.toast.show('Associating Photos', 3000);

          this.associationResults = await AssociatePhotos(this.jobId, nodes, connections, photosToAssociate, { saveSyncedTime: true });
          Object.assign(this.associationResults.update, update);
          this.commitAssociation();
        }
      );
    }
    // otherwise, prompt to to select a sync photo from the list
    else {
      this.$.photoControls.confirm(
        'Association Warning',
        'You are missing a sync photo in your selection of photos. Select a sync photo to perform photo association.',
        'Okay',
        '',
        'background-color:var(--secondary-color); color:white',
        null,
        async () => {}
      );
    }
  }

  async commitAssociation() {
    // Actions for Photofirst
    for (let id in this.associationResults.nodePhotoFirstEditors) {
      let ids = id.split(':');
      let jobId = ids[0];
      let nodeId = ids[1];
      let item = this.associationResults.nodePhotoFirstEditors[id];
      let firestoreRef = firebase.firestore().collection(`companies/${this.userGroup}/action_tracking`);
      // TODO-WARN: Hard coding of id is not a long-term solution
      firestoreRef
        .where('job_id', '==', jobId)
        .where('action_id', '==', '-McL2dSwnbOrpU5TTiNY')
        .where('node_id', '==', nodeId)
        .get()
        .then((s) => {
          if (s.empty) {
            firestoreRef.add({
              uid: item.uid,
              timestamp: item.timestamp || firebase.firestore.FieldValue.serverTimestamp(),
              time_of_association: firebase.firestore.FieldValue.serverTimestamp(),
              job_id: jobId,
              node_id: nodeId,
              action_name: 'PhotoFirst',
              action_id: '-McL2dSwnbOrpU5TTiNY',
              order: 3
            });
          }
        });
    }

    FirebaseWorker.ref().update(this.associationResults.update);

    // Update Counters
    for (let camera of this.associationResults.cameras) {
      if (!camera.folder_id) {
        // Find the folderId if we don't have it
        let folders = await FirebaseWorker.ref('photoheight/jobs/' + this.jobId + '/photo_folders')
          .once('value')
          .then((s) => s.val());
        folderLoop: for (var folderId in folders) {
          for (let cameraId in folders[folderId].cameras) {
            if (cameraId == camera.camera_id) {
              camera.folder_id = folderId;
              break folderLoop;
            }
          }
        }
      }
      // Increment the counters
      IncrementFolderCounter(this.jobId, camera.folder_id, camera.camera_id, this.userGroup, 'numAssociated', {
        count: camera.numAssociated
      });
      if (camera.numTagged) {
        IncrementFolderCounter(this.jobId, camera.folder_id, camera.camera_id, this.userGroup, 'numTagged', { count: camera.numTagged });
      }
    }

    this.$.toast.show('Finished associating photos', 3000);

    let generalWarnings = this.associationResults.warnings.map((x) => x.message);
    let unassociatedPhotoCount = this.associationResults.numPhotosToAssociate - this.associationResults.numAssociated;
    // Create general warnings for association issues
    if (unassociatedPhotoCount < 0) {
      generalWarnings.push(
        `At least ${Math.abs(unassociatedPhotoCount)} photos double associated. Please check for bad, long time buckets and remove them.`
      );
    } else if (unassociatedPhotoCount) {
      generalWarnings.push(
        `${unassociatedPhotoCount} photos left unassociated. Please double check that your time sync markers reflect exactly what is in the sync photo.`
      );
    }

    // display dialog warnings
    this.warningsDialogDataTitle = 'Association Results';
    this.warningsDialogDataSummary = generalWarnings.length ? generalWarnings.join('\r\n') : 'No warnings to display';
    this.$.warningsDialog.open();

    this.selectedPhotos = [];
  }

  setScrollSensitivity(scroll_sensitivity) {
    if (scroll_sensitivity) this.scrollSensitivity = scroll_sensitivity * 0.1 + 1.0;
    else this.scrollSensitivity = 1.0;
  }
}

customElements.define('photo-first', PhotoFirst);
